export const en = {
  translation: {
    nav: {
      dashboard: "Dashboard",
      orders: "Orders",
      transactions: "Transactions",
      refunds: "Refunds",
      menu: "Menu",
      categories: "Menu Categories",
      vouchers: "Vouchers",
      bundles: "Bundles",
      stalls: "Stalls",
      stallApplications: "Stall Applications",
      paymentMethods: "Payment Methods",
      deliveryProviders: "Delivery Providers",
      smsProviders: "SMS Providers",
      banners: "Promo Banners",
      adminAccounts: "Admin Accounts",
      staff: "Staff",
      customers: "Customers",
      reports: "Reports",
      activity: "Activity Log",
      flags: "Feature Flags",
      pricingRules: "Pricing Rules",
      hours: "Hours & Holidays",
      legalContent: "Legal Content",
      settings: "Settings",
      brandTitle: "Kopitiam Admin",
      brandSubtitle: "Command Center",
    },
    notFound: { title: "This page doesn't exist", desc: "There is no page at this address. The link may be outdated or mistyped.", toDashboard: "Back to dashboard", goBack: "Go back" },
    common: {
      openMenu: "Open navigation",
      close: "Close",
      previousPage: "Previous",
      nextPage: "Next",
      save: "Save",
      cancel: "Cancel",
      confirm: "Confirm",
      delete: "Delete",
      edit: "Edit",
      create: "Create",
      refresh: "Refresh",
      loading: "Loading…",
      noData: "No data",
      total: "{{count}} records",
      success: "Success",
      failed: "Operation failed, please try again",
      signOut: "Sign out",
      confirmDelete: "Delete this item?",
      selectStall: "Select stall",
      yes: "Yes",
      no: "No",
      back: "Back",
      stall: "Stall",
      saved: "Saved",
      search: "Search orders (no. / customer name / phone), press Enter…",
      exportCsv: "Export CSV",
      clearFilters: "Clear filters",
      guest: "Guest",
      connectionTestOk: "{{message}}",
      connectionTestOkWithLatency: "{{message}} ({{ms}} ms)",
      connectionTestFailed: "{{message}}",
      system: "System",
      switchLangEn: "English",
      switchLangZh: "中文",
      language: "Language",
      swipeForMore: "Swipe →",
      all: "All",
      active: "Active",
      disabled: "Disabled",
      savePct: "Save RM {{amount}} ({{pct}}% off)",
      pickupOnly: "Pickup only",
      deliveryOnly: "Delivery only",
      pickupAndDelivery: "Pickup & delivery",
      noExpiry: "No expiry",
      saveChanges: "Save changes",
      tablePageRange: "{{start}}–{{end}} of {{total}}",
    },
    auth: {
      brandName: "KawKaw Kopitiam",
      login: "Admin Login",
      email: "Email",
      password: "Password",
      loginBtn: "Login",
      loginFailed: "Invalid email or password",
      loginErrorDetail: "Invalid email or password. Please try again.",
      brandTagline:
        "Operations console — manage outlets, staff, menu, and orders in one place.",
      featureOrder: "Live order management",
      featureStaff: "Staff & permissions",
      featureReports: "Sales reports & analytics",
      featureSettings: "Outlet & brand settings",
      copyright: "© 2026 KawKaw Kopitiam",
      welcomeBack: "Welcome back",
      signInSubtitle: "Sign in with your admin account to continue",
      emailLabel: "Email address",
      passwordLabel: "Password",
      emailRequired: "Please enter your email",
      emailInvalid: "Please enter a valid email",
      passwordRequired: "Please enter your password",
      passwordPlaceholder: "Enter your password",
      signInBtn: "Sign in →",
      demoCredentials: "🔑 Demo accounts",
      demoSuperLine: "{{email}} / {{password}} — Super admin",
      demoAdminLine: "{{email}} / {{password}} — Admin",
      emailPlaceholder: "admin@kawkaw.my",
    },
    orders: {
      title: "Orders",
      colOrderId: "Order ID",
      colCustomer: "Customer",
      colTotal: "Total",
      colStatus: "Status",
      colPayment: "Payment",
      colPlacedAt: "Placed At",
      searchPlaceholder: "Search order ID / customer",
filteredByCustomer: "Filtered by customer",
      filterStatus: "Filter status",
      drawerStatus: "Status",
      drawerTotal: "Total",
      drawerPayment: "Payment",
      drawerCustomer: "Customer",
      drawerPlaced: "Placed",
      drawerNotes: "Notes",
      drawerItems: "Items",
      drawerSubtotal: "Subtotal",
      drawerDiscount: "Discount",
      drawerSST: "SST",
      drawerDelivery: "Delivery Fee",
      status: {
        new: "New",
        pending: "Pending",
        confirmed: "Confirmed",
        preparing: "Preparing",
        ready: "Ready",
        completed: "Completed",
        cancelled: "Cancelled",
        delivered: "Delivered",
        out_for_delivery: "Out for delivery",
        in_transit: "In transit",
      },
      type: {
        pickup: "Pickup",
        delivery: "Delivery",
      },
      cancelSuccess: "Order cancelled",
      cancelFailed: "Failed to cancel order",
      cancelModalTitle: "Cancel order",
      cancelConfirm: "Cancel order",
      cancelHint:
        "The order will be marked cancelled and the customer notified. Handle refunds separately in Refunds.",
      cancelReason: "Reason (logged)",
      cancelReasonPlaceholder:
        "e.g. duplicate order, customer request, out of stock…",
      cancelOrderAction: "Cancel order",
      filterAll: "All",
      listHeading: "Orders",
      liveFeedActive: "Live feed: {{count}} active orders",
      filterType: "TYPE:",
      typeDisabledWalkinHint: "Walk-in orders are always self-pickup — never delivery",
      colAmount: "Amount",
      colOrderTime: "Order time",
      colAction: "Action",
      menuOverview: "Overview",
      menuFullDetails: "Full details",
      menuCancelOrder: "Cancel order",
      actionMarkReady: "Mark ready",
      actionPickedUp: "Picked up",
      actionOutForDelivery: "Out for delivery",
      actionDelivered: "Delivered",
      actionMarkAsReady: "Mark as ready",
      actionMarkDelivered: "Mark delivered",
      drawerChannelDelivery: "Delivery",
      drawerChannelPickup: "Self pickup",
      drawerPaid: "Paid",
      drawerCancelReason: "Cancellation reason",
      drawerUnpaid: "Payment pending",
      drawerPaymentFailed: "Payment failed",
      drawerUnpaidBadge: "UNPAID",
      drawerPaymentFailedBadge: "FAILED",
      drawerCustomerDetails: "Customer details",
      drawerDeliveryTime: "Delivery time",
      drawerRider: "Rider",
      drawerLalamoveId: "Lalamove order no.",
      drawerTrack: "Tracking link",
      drawerProgress: "Delivery progress",
      lmAssigning: "Finding a rider",
      lmOnGoing: "Rider heading to the shop",
      lmPickedUp: "Picked up, on the way",
      lmCompleted: "Delivered",
      lmFailed: "Delivery failed",
      drawerPickupTime: "Pickup time",
      drawerOrderItemsCount: "Order items ({{count}})",
      drawerTotalAmount: "Total amount",
      drawerPaymentMethod: "Payment method",
      drawerPaidBadge: "PAID",
      drawerAsap: "ASAP",
      updateStatusFailed: "Failed to update order status",
      statusTabNew: "New",
      statusTabPreparing: "Preparing",
      statusTabReady: "Ready",
      statusTabOutForDelivery: "Out for delivery",
      statusTabInTransit: "In transit",
      statusTabDelivered: "Delivered",
      statusTabCompleted: "Completed",
      statusTabCancelled: "Cancel",
      filterAllStalls: "All stalls",
      discountWithCode: "Discount ({{code}})",
      voucherFallback: "VOUCHER",
      sstWithRate: "SST ({{rate}}%)",
    },
    refundDetail: {
      notFound: "Refund not found.",
      back: "Back",
      title: "Refund details",
      status: {
        success: "COMPLETED",
        pending: "PROCESSING",
        rejected: "REJECTED",
        failed: "FAILED",
      },
      typeFull: "Full refund",
      typePartial: "Partial refund",
      timelineCreated: "Refund created",
      timelineProcessing: "Processing",
      timelineCompleted: "Refund completed",
      timelineRejected: "Refund rejected",
      timelineFailed: "Gateway refund failed",
      staffSystem: "System",
      staffAdmin: "Admin",
      staffGateway: "Fiuu gateway",
      gatewayFailureTitle: "Gateway refund failed",
      autoRefundBadge: "Auto-refunded via Fiuu",
      gatewayRefundIdLabel: "Gateway refund ID",
      refundIdLabel: "Refund ID",
      refundAmount: "Refund amount",
      amountReclaimedLabel: "Amount reclaimed",
      refundType: "Refund type",
      createdTime: "Created time",
      requestSource: "Request source",
      requestSourcePos: "POS terminal",
      customerInfo: "Customer info",
      guest: "Guest",
      noCustomer: "No customer info",
      phone: "Phone",
      email: "Email",
      transactionInfo: "Transaction info",
      viewTransaction: "View transaction →",
      transactionId: "Transaction ID",
      orderId: "Order ID",
      paymentMethod: "Payment method",
      totalPaid: "Total paid",
      refundReason: "Refund reason",
      internalNote: "Internal note",
      transferDetails: "Transfer details",
      method: "Method",
      time: "Time",
      merchantNoteUpper: "MERCHANT NOTE",
      processTimeline: "Process timeline",
      dash: "—",
    },
    orderDetail: {
      invalidId: "Invalid order ID.",
      notFound: "Order not found.",
      back: "Back",
      statusMessageLabel: "Status message",
      orderPrefix: "Order",
      paid: "Paid",
      asap: "ASAP",
      customer: "Customer",
      customerShortId: "CUST-{{id}}",
      pickupTime: "Pickup time",
      customerWillArrive: "Customer will arrive to collect",
      cancelledTime: "Order cancelled time",
      orderCancelledAt: "Order was cancelled",
      deliveryAddress: "Delivery address",
      rider: "Rider",
      riderCancelled: "Order cancelled — no delivery",
      riderDelivered: "Delivered",
      findingRider: "Finding a rider...",
      deliveryFailed: "Delivery failed — needs manual action",
      resubmitLalamove: "Resubmit to Lalamove",
      resubmitLalamoveTitle: "Resubmit to Lalamove",
      resubmitLalamoveDesc: "This will request a new Lalamove quote and dispatch a new rider for this order.",
      resubmitLalamoveConfirm: "Resubmit",
      resubmitLalamoveSuccess: "Resubmitted to Lalamove — new rider dispatch requested",
      resubmitLalamoveFailed: "Failed to resubmit to Lalamove",
      pickupTimeRider: "Stall finished preparing at",
      riderWillArrive: "Food is ready, waiting for a rider to collect",
      riderHeadingToShop: "Rider is heading to the restaurant to collect",
      etaArrive: "Arriving around {{time}} (estimate)",
      distanceNotRecorded: "Distance: not recorded (shop had no coordinates when ordered)",
    riderPlate: "Plate",
      deliveredAtLabel: "Delivered at",
      deliveredNote: "Order delivered",
      deliverConfirmTitle: "Mark as delivered?",
      deliverConfirmDesc: "Once delivered the order can no longer be cancelled and the customer is told it has arrived.",
      deliverForcePrompt: "The rider has not picked the order up yet. If it really was delivered, enter the reason (min. 3 characters):",
      trackRider: "Track rider →",
      specialNote: "Special note",
      rating: "Customer rating",
      orderItems: "Order items",
      itemsTotal: "{{count}} item(s) total",
      basePriceMarkup: "Base RM {{base}} + markup RM {{markup}}",
      addonCostMarkup: "Add-on RM {{cost}} + add-on markup RM {{markup}}",
      stallPrefix: "Stall",
      basePriceTotal: "Base price total",
      markupTotal: "Markup total",
      addonCostTotal: "Add-on cost total",
      addonMarkupTotal: "Add-on markup total",
      subtotal: "Subtotal",
      discount: "Discount",
      deliveryFee: "Delivery fee",
      sstPercent: "SST ({{rate}}%)",
      sstIncludedRow: "SST (included in price)",
      total: "TOTAL",
      customerPaidAmount: "Customer paid amount",
      refundHistory: "Refund history",
      noRefunds: "No refund history for this order.",
      createRefund: "Create refund",
      transactionDetails: "Transaction details",
      method: "Method",
      status: "Status",
      paidUpper: "PAID",
      transactionId: "Transaction ID",
      viewTransaction: "View transaction",
      noTxnRecord: "No transaction record",
      orderJourney: "Order journey",
      cancelOrder: "Cancel order",
      printReceipt: "Print receipt",
      markAsReady: "Mark as ready",
      pickedUp: "Picked up",
      outForDelivery: "Out for delivery",
      markDelivered: "Mark delivered",
      cancelModalTitle: "Cancel order",
      cancelOk: "Cancel order",
      reasonLabel: "Reason for cancellation",
      reasonPlaceholder: "e.g. Customer requested cancellation",
      reasonRequired: "Please enter a reason (min 3 characters)",
      statusUpdated: "Order status updated",
      updateStatusFailed: "Failed to update status",
      cancelSuccess: "Order cancelled",
      cancelFailed: "Failed to cancel order",
      refundFormTitle: "Refund form",
      refundOrderSummary: "Payment summary",
      refundPaidAmount: "Paid amount",
      refundMaxAmount: "Max refundable: RM {{amount}}",
      refundType: "Refund type",
      refundAmount: "Refund amount",
      refundMethod: "Refund method",
      refundReason: "Refund reason",
      refundReasonPlaceholder: "e.g. POS order cancelled after payment",
      submitRefund: "Submit refund",
      refundCreated: "Refund request created",
      refundCreateFailed: "Failed to create refund",
      refundNoPaidTxn: "This order has no successful payment transaction.",
      refundNoPaymentTitle: "Payment not completed",
      refundNoPaymentDesc: "Refunds can only be created after the customer has successfully paid.",
      refundAmountInvalid: "Please enter a valid refund amount.",
      refundReasonRequired: "Please enter a refund reason.",
      payment: {
        visa: "Visa/Mastercard",
        fpx: "FPX Online Banking",
        grabpay: "GrabPay",
        cash: "Cash",
        ewallet: "eWallet",
        tng: "Touch 'n Go",
        boost: "Boost",
      },
      statusMsg: {
        new: "Waiting for stall to accept this order",
        preparing: "Stall is preparing the order",
        readyPickup: "Order is ready — waiting for customer pickup",
        readyDelivery: "Order ready — awaiting rider assignment",
        outForDelivery: "Rider is on the way to collect",
        pickedUp: "Rider has picked up the food and is on the way",
        deliveryIssue: "Delivery ran into an issue — see rider status below",
        inTransit: "Order is out for delivery",
        delivered: "Order has been delivered to customer",
        completedPickup: "Order picked up by customer",
        completedDelivery: "Order completed",
        cancelled: "Order cancelled",
      },
      journey: {
        orderCreated: "Order created",
        accepted: "Accepted",
        preparing: "Preparing",
        ready: "Ready",
        waitingPickup: "Waiting for pickup",
        riderAssigned: "Rider assigned",
        riderArrived: "Rider arrived",
        outForDelivery: "Out for delivery",
        delivered: "Delivered",
        pickedUp: "Picked up",
        cancelledBy: "Order cancelled by {{name}}",
        unknownCanceller: "staff",
      },
      journeyCurrent: "(Current)",
      journeyPending: "Pending",
      journeyTimeCurrent: "{{time}} (Current)",
      refundRowStatus: {
        success: "Success",
        pending: "Pending",
        failed: "Failed",
      },
      txnPending: "Pending",
    },
    transactionDetail: {
      notFound: "Transaction not found.",
      breadcrumb: "Transaction details",
      totalAmount: "Total amount",
      paymentMethod: "Payment method",
      colProvider: "PROVIDER",
      colReferenceId: "REFERENCE ID",
      colAuthorization: "AUTHORIZATION",
      merchantReference: "Merchant reference",
      success: "Success",
      paymentBreakdown: "Payment breakdown",
      subtotal: "Subtotal",
      deliveryFee: "Delivery fee",
      taxSst: "Tax (SST {{rate}}%)",
      discount: "Discount",
      finalPaidAmount: "Final paid amount",
      partialRefundIssued: "Partial refund issued",
      fullRefundIssued: "Full refund issued",
      reason: "REASON",
      method: "METHOD",
      viaPrefix: "Via {{method}}",
      merchantInternalNote: "MERCHANT INTERNAL NOTE",
      customerInfo: "Customer info",
      noCustomer: "No customer info",
      viewOrderDetails: "View order details →",
      transactionHistory: "Transaction history",
      issueRefund: "Issue refund",
      downloadReceipt: "Download receipt",
      orderIdLabel: "Order ID",
      statusPaid: "PAID",
      statusPartialRefund: "PARTIAL REFUND",
      statusRefunded: "REFUNDED",
      statusRefundPending: "REFUND PENDING",
      statusPending: "PENDING",
      statusFailed: "FAILED",
      timelinePaid: "Payment completed (success)",
      timelineInitiated: "Payment initiated",
      timelineRefundInitiated: "Refund initiated",
      timelineRefundApproved: "Refund approved",
      timelineRefundRejected: "Refund rejected",
      timelineOrderCancelled: "Order cancelled by admin",
      refundMetaDesc: "Type: {{type}}, Amount: RM {{amount}}, Method: {{method}}",
      refundTypePartial: "partial",
      refundTypeFull: "full",
      timelineNote: "Note",
      timelineTransferTime: "Transfer time",
      timelineTransferMethod: "Transfer method",
      checkoutBy: "{{name}} checkout",
      authCode: "Auth Code: {{reference}}",
      authSuccess: "Success",
    },
    staff: {
      stallRequired: "A stall must be assigned for stall staff accounts",
      noSessions: "No login sessions in this period",
      lastLoginToday: "Today, {{time}}",
      lastLoginYesterday: "Yesterday",
      lastLoginDaysAgo: "{{count}} days ago",
      none: "—",
      historyDate: "DATE",
      historyTablet: "TABLET",
      historyLogin: "LOGIN",
      historyLogout: "LOGOUT",
      historyDuration: "DURATION",
      historyStatus: "STATUS",
      online: "ONLINE",
      completed: "COMPLETED",
      totalSessions: "TOTAL SESSIONS",
      avgDuration: "AVG DURATION",
      dailyAverage: "Daily average",
      lastSeen: "LAST SEEN",
      exportCsv: "Export CSV",
      close: "Close",
      loginHistoryTitle: "Login history",
      roleAdmin: "ADMIN",
      roleStaffLabel: "STAFF",
      saveChanges: "Save changes",
      saveStaff: "Save staff →",
      editStaff: "Edit staff",
      addStaff: "Add staff",
      personalInfo: "PERSONAL INFO",
      fullName: "FULL NAME",
      placeholderFullName: "e.g. Wei Kang",
      placeholderPhone: "+60 12–345 6789",
      fullNameRequired: "Full name is required",
      phoneNumber: "PHONE NUMBER",
      phoneInvalid: "Enter a valid Malaysian phone number, e.g. 0123456789",
      phoneInUse: "This phone number is already in use",
      emailInUse: "This email is already in use",
      phoneRequired: "Phone number is required",
      roleAccess: "ROLE & ACCESS",
      admin: "Admin",
      staff: "Staff",
      posOperator: "POS Operator",
      roleInfoAdmin: "Can access all features including reports, menu, and staff management.",
      roleInfoStall: "Logs into the stall app — sees and manages orders for their assigned stall's kitchen queue only.",
      roleInfoPos: "Logs into the POS app to record walk-in sales and manage orders. Leave the stall unassigned for an all-stalls front-counter terminal, or assign one stall to scope this login to that stall's orders only.",
      assignedTablet: "ASSIGNED TABLET",
      assignedStallPos: "ASSIGNED STALL (OPTIONAL)",
      notAssigned: "Not assigned",
      notAssignedAllStalls: "Not assigned (sees all stalls)",
      loginPin: "LOGIN PIN",
      setupPin: "SETUP PIN",
      confirmPin: "CONFIRM PIN",
      pinRequired: "PIN is required",
      pinLen: "PIN must be exactly 4 digits",
      pinNumeric: "PIN must be numeric",
      confirmPinRequired: "Please confirm the PIN",
      pinMismatch: "PINs do not match",
      pinHint: "Staff will use this PIN to log in on the tablet. Ensure it is unique and confidential.",
      updatedOk: "Staff updated successfully",
      addedOk: "Staff added successfully",
      saveFailed: "Failed to save staff. Please try again.",
      cancel: "Cancel",
      resetPinTitle: "Reset PIN",
      resetPinBtn: "Reset PIN →",
      newPinSection: "NEW PIN",
      newPin: "NEW PIN",
      pinResetOk: "PIN reset successfully",
      pinResetFailed: "Failed to reset PIN",
      resetPinHint: "The new PIN will take effect immediately. The staff member will need to use it on their next login.",
      pinLenReset: "PIN must be 4 digits",
      numericOnly: "Numeric only",
      managementTitle: "Staff management",
      pageSubtitle: "Manage operational staff, assignments and login access.",
      addStaffBtn: "Add staff",
      periodToday: "Today",
      periodWeek: "This week",
      periodMonth: "This month",
      totalStaff: "TOTAL STAFF",
      teamMembers: "Team members",
      active: "ACTIVE",
      currentlyWorking: "Currently working",
      inactive: "INACTIVE",
      offDuty: "Off duty",
      searchPlaceholder: "Search name or phone…",
      allRoles: "All roles",
      allStatus: "All status",
      activeStatus: "Active",
      inactiveStatus: "Inactive",
      colStaffDetails: "STAFF DETAILS",
      colRole: "ROLE",
      colAssignedTablet: "ASSIGNED TABLET",
      colStatus: "STATUS",
      colLastLogin: "LAST LOGIN",
      colActions: "ACTIONS",
      notAssignedTablet: "Not assigned",
      statusActive: "● Active",
      statusInactive: "● Inactive",
      edit: "Edit",
      loginHistory: "Login history",
      resetPassword: "Reset password",
      removeStaff: "Remove staff",
      removedOk: "Staff removed",
      removeFailed: "Failed to remove staff",
      showingCount: "Showing {{filtered}} of {{total}} staff members",
      // Admin Accounts screen (/admins)
      adminAccountsTitle: "Admin Accounts",
      adminAccountsSubtitle: "Manage dashboard login accounts, access permissions and status",
      adminStatTotal: "Total administrators",
      adminStatActive: "Active",
      adminStatInactive: "Inactive",
      adminStatBadgeOverall: "All accounts",
      adminStatBadgeActive: "Can sign in",
      adminStatBadgeInactive: "Paused",
      adminDrawerSubtitleNew: "Configure account details and accessible features",
      adminDrawerSubtitleEdit: "Update account details, password and permissions",
      addAdminBtn: "Add Admin",
      editAdmin: "Edit Admin",
      colEmail: "Email",
      emailRequired: "A valid email is required",
      placeholderEmail: "example@kawkaw.my",
      passwordLabel: "Password",
      passwordPlaceholderCreate: "At least 8 characters",
      passwordPlaceholderEdit: "Leave blank to keep the current password",
      passwordRequired: "Password is required",
      passwordMinLength: "Password must be at least 8 characters",
      permissionsTitle: "Permissions",
      permissionsHint: "Select which modules this admin can access.",
      colPermissions: "Permissions",
      allPermissions: "All permissions",
      noPermissions: "No permissions",
      morePermissions: "+{{count}} more",
      superadminBadge: "Super Admin",
      superadminLockedHint: "Superadmin has full access — role and permissions can't be edited.",
      todayWeekMonthToday: "Today",
      todayWeekMonthWeek: "This week",
      todayWeekMonthMonth: "This month",
      editTitle: "Edit Staff",
      addTitle: "Add Staff",
      colName: "Name",
      colPhone: "Phone",
      colStall: "Stall",
      colCreated: "Created",
      tooltipEdit: "Edit staff",
      tooltipResetPin: "Reset PIN",
      formInitialPin: "Initial PIN (4 digits)",
      formPinLengthMsg: "PIN must be exactly 4 digits",
      formAssignedStall: "Assigned Stall (for stall role)",
      formNewPin: "New PIN",
      formConfirmPin: "Confirm PIN",
      pinDigitsMsg: "4–6 digits",
      pinResetSuccess: "PIN reset — temporary PIN: {{pin}} (share with staff)",
      pinResetSuccessSimple: "PIN reset successfully",
      createSuccess: "Staff created",
      updateSuccess: "Staff updated",
    },
    customers: {
      managementTitle: "Customer Management",
      pageSubtitle: "View and manage app customers — profiles, addresses, orders, and access.",
      searchPlaceholder: "Search name, phone or email…",
      allStatus: "All status",
      activeStatus: "Enabled",
      inactiveStatus: "Disabled",
      colName: "Customer",
      colContact: "Contact",
      colStatus: "Status",
      colOrders: "Orders",
      colRegistered: "Registered",
      colActions: "Actions",
      statusActive: "Enabled",
      statusInactive: "Disabled",
      viewDetail: "View detail",
      detailTitle: "Customer Detail",
      close: "Close",
      profile: "Profile",
      fullName: "Name",
      email: "Email",
      phone: "Phone",
      registeredVia: "Registered via",
      registeredOn: "Registered on",
      save: "Save",
      saveSuccess: "Customer updated",
      saveFailed: "Failed to update customer",
      accountStatus: "Account status",
      enabled: "Enabled",
      disabled: "Disabled",
      enableConfirmTitle: "Enable this customer?",
      disableConfirmTitle: "Disable this customer?",
      disableConfirmDesc: "The customer will not be able to log in until re-enabled.",
      disableAction: "Disable",
      statusUpdateSuccess: "Account status updated",
      statusUpdateFailed: "Failed to update account status",
      addresses: "Addresses",
      noAddresses: "No saved addresses",
      defaultAddress: "Default",
      recentOrders: "Recent Orders",
      noOrders: "No orders yet",
      viewAllOrders: "View all orders →",
      resetPassword: "Reset Password",
      resetPasswordConfirmTitle: "Reset this customer's password?",
      resetPasswordConfirmDesc: "This generates a temporary password the customer can log in with right away — they'll be required to set their own new password on that next login.",
      resetPasswordFailed: "Failed to reset password",
      tempPasswordTitle: "Temporary password generated",
      tempPasswordDesc: "Give the customer this temporary password: {{password}}\nThey'll be asked to set a new one after logging in. This is shown only once — copy it now.",
      tempPasswordCopied: "Copied",
      totalCustomers: "Total Customers",
      enabledCount: "Enabled",
      disabledCount: "Disabled",
    },
    stallApplications: {
      title: "Stall Applications",
      pageSubtitle: "Review stall applications and manage approval decisions",
      statTotal: "Total applications",
      statPending: "Pending review",
      statApproved: "Approved",
      statRejected: "Rejected",
      statBadgeOverall: "Overall",
      statBadgePending: "To review",
      statBadgeApproved: "Approved",
      statBadgeRejected: "Rejected",
      colCreatedAt: "Applied At",
      colStallName: "Stall Name",
      colCategory: "Category",
      colContact: "Contact",
      colStatus: "Status",
      colReviewer: "Reviewer",
      colActions: "Actions",
      filterStatus: "Filter by status",
      viewDetail: "View Details",
      detailTitle: "Application Detail",
      labelDescription: "Description",
      labelContactPhone: "Contact Phone",
      labelContactEmail: "Email",
      labelReviewNote: "Review Note",
      labelAppliedAt: "Applied At",
      sortOrderLabel: "Stall Sort Order (lower = first)",
      reviewNoteOptional: "Review Note (optional)",
      rejectionPlaceholder: "Reason for rejection…",
      reviewNotePlaceholder: "Optional note…",
      confirmApprove: "Confirm Approve",
      confirmReject: "Confirm Reject",
      approveModalTitle: "Approve Application",
      rejectModalTitle: "Reject Application",
      approveDescription: "Approving will automatically create stall \"{{name}}\" in the system.",
      rejectDescription: "You are rejecting the application from \"{{name}}\".",
      status: {
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
      },
      approve: "Approve",
      reject: "Reject",
      reviewNote: "Review Note",
      rejectionReason: "Rejection Reason (min 5 chars)",
      approvedMsg: "Application approved — stall created!",
      rejectedMsg: "Application rejected.",
      failedMsg: "Operation failed, please try again.",
    },
    dashboard: {
      unitsSold: "{{count}} sold",
      orderFlowTitle: "Order flow",
      orderFlowSubtitle: "Preparation, pickup and delivery at a glance",
      todayRevenue: "Today's Revenue",
      todayOrders: "Today's Orders",
      pendingRefunds: "Pending Refunds",
      activeStaff: "Active Staff",
      totalRevenue: "Total Revenue",
      totalOrdersToday: "Total Orders Today",
      pickupOrders: "Pickup Orders",
      deliveryOrders: "Delivery Orders",
      newNow: "Awaiting acceptance",
      todayOrdersShort: "Orders today",
      preparingNow: "Preparing Now",
      readyForPickup: "Ready for Pickup",
      readyForDelivery: "Ready for Delivery",
      channelDistribution: "Channel Distribution",
      revenueTrend: "Revenue Trend",
      revenueTrendSub: "Daily performance across channels",
      todayTab: "Today",
      weeklyTab: "Weekly",
      topSelling: "Top Selling Items",
      noSalesToday: "No sales data for today",
      recentActivity: "Recent Activity",
      viewAllHistory: "View all history",
      colOrderId: "Order ID",
      colChannel: "Channel",
      colCustomer: "Customer",
      colAmount: "Amount",
      colStatus: "Status",
      colTime: "Time",
      colAction: "Action",
      viewDetails: "View details",
      ordersUnit: "orders",
      today: "Today",
      fromYesterday: "from yesterday",
      current: "Current",
      todayLabel: "Today",
      pickup: "Pickup",
      delivery: "Delivery",
      tooltipRevenue: "Revenue",
      topItemOrders: "{{count}} orders",
      topItemPeriodToday: "Today",
      topItemPeriodAll: "All data",
      donutPickupShare: "PICKUP",
      avgOrderValue: "Average Order Value",
      pickupShare: "Pickup Share",
      deliveryShare: "Delivery Share",
      revenueMovement: "Revenue Movement",
      revenueUp: "Up",
      revenueDown: "Down",
    },
    menu: {
      title: "Menu Management",
      addItem: "Add Item",
      editTitle: "Edit Menu Item",
      addTitle: "Add Menu Item",
      selectStallPrompt: "Select a stall to view menu items",
      colImage: "Image",
      colName: "Name",
      colCategory: "Category",
      colPrice: "Price",
      colAvailable: "Available",
      colStock: "Stock",
      formImage: "Image",
      formName: "Name",
      formDescription: "Description",
      formCategory: "Category",
      formPrice: "Price (RM)",
      formDailyStock: "Daily Stock Limit (leave blank = unlimited)",
      formDailyStockPlaceholder: "e.g. 50",
      formAvailableFrom: "Available From (HH:MM)",
      formAvailableTo: "Available Until (HH:MM)",
      formTimeAvailableFromPh: "07:00",
      formTimeAvailableToPh: "22:00",
      formOfferPricePlaceholder: "e.g. 4.50",
      formTimeOfferFromPh: "10:00",
      formTimeOfferToPh: "14:00",
      formIsAvailable: "Available",
      formSortOrder: "Sort Order",
      formOfferPrice: "Offer Price (RM) (leave blank = no offer)",
      formOfferFrom: "Offer From (HH:MM)",
      formOfferTo: "Offer Until (HH:MM)",
      createSuccess: "Item created",
      updateSuccess: "Item updated",
      deleteConfirm: "Delete this item?",
      deleteSuccess: "Item deleted",
      saveFailed: "Save failed",
      deleteFailed: "Delete failed",
      categoryOptionGroups: "Default option groups",
      categoryOptionGroupsTooltip: "New items in this category inherit these option groups, such as sugar, ice or spice levels. You can rename, add or remove them.",
      categoryOptionGroupsEmpty: "No default option groups yet",
      categoryOptionGroupNamePlaceholder: "Group name, e.g. Spice level",
      categoryOptionChoicePlaceholder: "e.g. Mild",
      categoryAddOptionGroup: "Add option group",
      manageOptions: "Options",
      optionsDrawerTitle: "Option Groups — {{name}}",
      addGroup: "Add Option Group",
      editGroup: "Edit Option Group",
      groupName: "Group Name",
      groupType: "Type",
      groupTypeRequired: "Required",
      groupTypeOptional: "Optional",
      groupMinSelect: "Min Select",
      groupMaxSelect: "Max Select",
      addChoice: "Add Choice",
      editChoice: "Edit Choice",
      choiceLabel: "Choice Label",
      choiceExtraCharge: "Extra Charge (RM)",
      groupSaved: "Group saved",
      groupDeleted: "Group deleted",
      choiceSaved: "Choice saved",
      choiceDeleted: "Choice deleted",
      confirmDeleteGroup: "Delete this option group?",
      confirmDeleteChoice: "Delete this choice?",
      formGroupIcon: "Icon",
      groupIconSugar: "Sugar level",
      groupIconIce: "Ice level",
      groupIconSpecial: "Special request",
      choiceInputType: "Type",
      choiceTypeRadio: "Radio",
      choiceTypeInputBox: "Input box",
      choiceTypeTextarea: "Textarea",
      choiceTypeQuantity: "Quantity add-on",
      choiceTypeHelp: "Types: Radio = tap to pick (optional surcharge); Quantity add-on = paid extra with a − + stepper (e.g. Ham RM1.50); Input box / Textarea = free-text notes typed by the customer, no quantity.",
      choicePlaceholderLabel: "Placeholder text",
      choicePlaceholderExample: "e.g. Any special requests?",
      yourStalls: "Your Stalls",
      stallBadgeActive: "ACTIVE",
      stallBadgePaused: "PAUSED",
      selectStallFromLeft: "Select a stall to manage its menu.",
      managingSummary: "{{items}} · {{categories}}",
      itemCount_one: "{{count}} item",
      itemCount_other: "{{count}} items",
      categoryCount_one: "{{count}} category",
      categoryCount_other: "{{count}} categories",
      colHeaderItemName: "ITEM NAME",
      colHeaderCategory: "CATEGORY",
      sortTitle: "Drag to reorder", listView: "List", sortView: "Reorder", searchPlaceholder: "Search item name", allCategories: "All categories", uncategorized: "Uncategorised", sortHint: "Hold ⠿ and drag to reorder; saves on drop. The customer menu follows this order (pinned items always lead).", sortFilteredHint: "Only filtered items are shown; reordering only changes their order relative to each other.", sortSaved: "Order saved", sortFailed: "Failed to save order", sortEmpty: "No matching items", sortPinned: "Pinned", sortUnavailable: "Unavailable", sortTop: "Move to top", sortUp: "Move up", sortDown: "Move down", noMatch: "No matching items",
      colHeaderPriceRm: "PRICE (RM)",
      colHeaderAvailability: "AVAILABILITY",
      colHeaderLastUpdated: "LAST UPDATED",
      stallPanelTitle: "Stall Details",
      stallIdLabel: "Stall ID: #{{id}}",
      stallStatusTitle: "Stall Status",
      stallOnline: "ONLINE",
      stallOffline: "OFFLINE",
      pauseOrdersHint: "Pause orders temporarily",
      prepTimeSection: "Preparation Time",
      prepTimeMins: "mins",
      autoAcceptTitle: "Auto-Accept Orders",
      autoAcceptHint: "Recommended for high traffic",
      manageCategories: "Categories",
      categoriesDrawerTitle: "Categories — {{stall}}",
      addCategory: "Add Category",
      editCategory: "Edit Category",
      categoriesEmptyTitle: "No categories yet",
      categoriesEmptyHint: "Select Add Category to organise this stall’s menu.",
      categoryName: "Category Name",
      categorySortOrder: "Sort Order",
      categoryCreateSuccess: "Category created",
      categoryUpdateSuccess: "Category updated",
      categoryDeleteSuccess: "Category deleted",
      formCategoryId: "Category",
      formCategoryPlaceholder: "Select category (optional)",
      formCategoryEmoji: "Emoji",
      formCategoryName: "Category name",
      categoryEmoji: "Emoji",
      globalCategory: "Global",
      categoryEmojiHint: "Paste a single emoji (e.g. ☕). If an icon is uploaded, it takes priority",
      categoryIcon: "Icon / Image",
      categoryIconHint: "Upload a custom icon or image (shown instead of the emoji)",
      formCategoryEmojiPlaceholder: "e.g. ☕",
      categoryStallOptional: "Optional — leave blank for a global category",
      categorySugarChoices: "Sugar level choices",
      categorySugarChoicesTooltip:
        "If set, items in this category use these sugar options; leave empty for app defaults.",
      categorySugarChoicesEmpty: "Using app default",
      categorySugarChoicesPlaceholder: "e.g. 25% Less Sweet",
      categoryIceChoices: "Ice level choices",
      categoryIceChoicesTooltip:
        "If set, items in this category use these ice options; leave empty for app defaults.",
      categoryIceChoicesEmpty: "Using app default",
      categoryIceChoicesPlaceholder: "e.g. Less Ice",
    },
    transactions: {
      title: "Transactions",
      searchPlaceholder: "Search reference",
      filterStatus: "Status",
      statusSuccess: "Success",
      statusPending: "Pending",
      statusRefunded: "Refunded",
      statusFailed: "Failed",
      refundBtn: "Refund",
      refundModalTitle: "Refund",
      refundOriginal: "Original:",
      refundPaidVia: "paid via",
      refundType: "Refund Type",
      refundTypeFull: "Full refund",
      refundTypePartial: "Partial refund",
      refundAmount: "Refund Amount (RM)",
      refundMethod: "Refund Method",
      refundReason: "Reason",
      refundReasonPlaceholder: "Reason for refund…",
      submitRefund: "Submit Refund",
      refundInitiated: "Refund initiated — pending review",
      refundFailed: "Failed to initiate refund",
      pageTitle: "Transactions",
      statTotalTxns: "TOTAL TRANSACTIONS",
      statTotalRevenue: "AMOUNT RECEIVED (RM)",
      statTotalRevenueHint: "Amount received from successful transactions. Differs from the Reports order total, which includes unpaid orders and excludes cancelled ones.",
      statTotalRefunded: "TOTAL REFUNDED (RM)",
      statNetRevenue: "NET REVENUE (RM)",
      searchPlaceholderWide: "Search by ID, Customer or Order ID…",
      datePreset7d: "Last 7 Days",
      datePreset30d: "Last 30 Days",
      datePreset90d: "Last 90 Days",
      datePresetAll: "All Time",
      filterAllPaymentMethods: "All Payment Methods",
      filterAllStatus: "All Status",
      filterAllOrderTypes: "All Order Types",
      filterAllSources: "All Sources",
      sourceWalkin: "Walk-in (POS)",
      sourceCustomerApp: "Customer app",
      statusPartialRefund: "Partial Refund",
      colTxnId: "Transaction ID",
      colCustomerOrder: "Customer / Order",
      customerLabel: "Customer",
      colOrderType: "Order Type",
      colAmount: "Amount",
      colPayment: "Payment",
      colStatus: "Status",
      colDateTime: "Date & Time",
      actionViewDetails: "VIEW DETAILS",
      actionRefunds: "REFUNDS",
      actionReceipt: "RECEIPT",
      partialRefNote: "Ref",
      testFailedGeneric: "Test failed",
    },
    refunds: {
      title: "Refunds",
      pageHeading: "Refunds",
      colId: "ID",
      colAmount: "Amount",
      colReason: "Reason",
      colPaymentRef: "Payment Ref",
      colStatus: "Status",
      colRequested: "Requested",
      colActions: "Actions",
      colRefundId: "Refund ID",
      colTxnId: "Transaction ID",
      colCustomerOrder: "Customer / order",
      colType: "Type",
      colAction: "Action",
      filterStatus: "Filter status",
      statusPendingReview: "Pending Review",
      statusApproved: "Approved",
      statusRejected: "Rejected",
      approve: "Approve",
      reject: "Reject",
      approveTitle: "Approve Refund",
      rejectTitle: "Reject Refund",
      noteLabel: "Internal Note (optional)",
      notePlaceholder: "Add a note for audit trail…",
      approvedMsg: "Refund approved",
      rejectedMsg: "Refund rejected",
      reviewFailed: "Failed to process review",
      statTotalAmount: "Refunded total (successful only)",
      statTotalCount: "Refunds completed (successful only)",
      statPartialCount: "Partial refunds (successful only)",
      statTodayAmount: "Refunded today (successful only)",
      statSubVsLastMonth: "{{pct}} vs last month",
      statSubNoLastMonth: "No refunds last month",
      statAccumulatedMonth: "This month · pending not counted",
      statPartialPct: "{{pct}}% of total volume",
      statUpdatedNow: "Updated just now",
      dateRange: "Date range",
      refundType: "Refund type",
      paymentMethod: "Payment method",
      status: "Status",
      quickSearch: "Quick search",
      placeholderAllTypes: "All types",
      placeholderAllMethods: "All methods",
      placeholderAllStatus: "All status",
      placeholderSearch: "TXN ID / name",
      typeFull: "Full refund",
      typePartial: "Partial refund",
      statusPending: "Pending",
      statusSuccess: "Success",
      statusRejectedPill: "Rejected",
      statusFailed: "Failed",
      typeFullRef: "FULL REF",
      typePartialRef: "PARTIAL REF",
      pillSuccess: "SUCCESS",
      pillPending: "PENDING",
      pillRejected: "REJECTED",
      pillFailed: "FAILED",
      recentRecords: "Recent refund records",
      exportCsv: "Export CSV",
      exportPdf: "Export PDF",
      menuUpdateStatus: "Update status",
      menuViewDetails: "View details",
      menuViewOrders: "View orders",
      statusUpdated: "Refund status updated",
      statusUpdateFailed: "Failed to update refund status",
      modalTitle: "Update refund status",
      modalRefundId: "Refund ID:",
      summaryTitle: "Refund summary",
      customer: "Customer",
      orderId: "Order ID",
      transactionId: "Transaction ID",
      refundAmount: "Refund amount",
      currentStatus: "Current status:",
      updateStatus: "Update status",
      optCompleted: "COMPLETED",
      optRejected: "REJECTED",
      transferDetails: "Transfer details",
      transferMethod: "Transfer method",
      transferMethodRequired: "Choose how the customer was refunded",
      transferTime: "Transfer time",
      referenceNote: "Reference note",
      rejectionReason: "Rejection reason",
      placeholderTransferMethod: "Select method",
      placeholderTransferTime: "MM/DD/YYYY, HH:MM AM/PM",
      placeholderReference: "e.g. Maybank receipt #8812",
      placeholderRejection: "Reason for rejection…",
      transferEwallet: "E-wallet",
      transferBank: "Bank transfer",
      transferCash: "Cash",
      transferFpx: "FPX",
      transferCard: "Visa/card",
      warnConfirmTransfer: "Confirm the refund was transferred successfully. This cannot be undone.",
      cancel: "Cancel",
      confirmUpdate: "Confirm update",
      payVisa: "Visa / card",
      payFpx: "FPX",
      payGrab: "GrabPay",
      payCash: "Cash",
      payEwallet: "E-wallet",
      payTng: "Touch 'n Go",
      payBoost: "Boost",
      autoRefundTitle: "Automatic refund via Fiuu",
      autoRefundDesc: "This refund will be processed automatically via Fiuu, back to the customer's original payment method. No manual transfer details are needed.",
      warnConfirmAutoRefund: "This will trigger a real refund request to Fiuu. This cannot be undone.",
      autoRefundSuccessToast: "Refund processed automatically — funds returned via Fiuu",
      autoRefundPendingToast: "Refund submitted to Fiuu — still processing, check back shortly",
      autoRefundFailedToast: "Fiuu declined the refund{{reason}}",
    },
    vouchers: {
      sectionDistribution: "Distribution & Stacking",
      lblScope: "Scope",
      scopePlatform: "Platform (any stall)",
      scopeMerchant: "Merchant (one stall only)",
      lblDiscountTarget: "Discounts",
      targetSubtotal: "Item subtotal",
      targetDeliveryFee: "Delivery fee",
      lblMerchantStall: "Stall",
      merchantStallRequired: "Select the stall this merchant voucher belongs to",
      phMerchantStall: "Select a stall",
      lblNoMinimum: "No-minimum (red packet)",
      lblDailyUseCap: "Daily use cap",
      phUnlimited: "Unlimited",
      stackingHint: "Up to 3 vouchers can stack per order: one merchant, one platform, and one delivery-fee voucher — applied in that order, before SST.",
      title: "Vouchers",
      pageSubtitle: "Create, monitor and manage customer promotions",
      newVoucher: "New Voucher",
      editTitle: "Edit Voucher",
      newTitle: "New Voucher",
      colMinSpend: "Min Spend",
      colUses: "Uses",
      colStatus: "Status",
      colValidUntil: "Valid Until",
      formCode: "Code",
      formDiscountType: "Discount Type",
      formDiscountTypePercentage: "Percentage %",
      formDiscountTypeFixed: "Fixed Amount (RM)",
      formDiscountTypeFreeItem: "Free Item",
      formDiscountValue: "Discount Value",
      formMinSpend: "Minimum Spend (RM)",
      formUsageLimit: "Usage Limit (blank = unlimited)",
      formValidFrom: "Valid From",
      formValidUntil: "Valid Until",
      formStatus: "Status",
      formStatusActive: "Active",
      formStatusScheduled: "Scheduled",
      formStatusExpired: "Expired",
      formStatusDisabled: "Disabled",
      formStatusInactive: "Inactive",
      formSingleUse: "Single Use Per Customer",
      createSuccess: "Voucher created",
      updateSuccess: "Voucher updated",
      saveFailed: "Save failed",
      deleteConfirm: "Disable this voucher?",
      deleteConfirmDesc: "It will be marked disabled and unusable.",
      deleteSuccess: "Voucher disabled",
      deleteFailed: "Failed to disable voucher",
      pageCreateBtn: "Create Voucher",
      statBadgeOverall: "OVERALL",
      statBadgeActive: "ACTIVE",
      statBadgeInactive: "INACTIVE",
      statBadgeGrowth: "TOTAL",
      statTotalVouchers: "Total Vouchers",
      statActive: "Active",
      statExpired: "Expired",
      statTotalRedeemed: "Total Redeemed",
      searchPlaceholder: "Search by code or name…",
      filterAllStatus: "All Status",
      filterAllTypes: "All Types",
      colCode: "CODE",
      colVoucherName: "VOUCHER NAME",
      colType: "TYPE",
      colValue: "VALUE",
      colMinOrder: "MIN ORDER",
      colUsage: "USAGE",
      colValidPeriod: "VALID PERIOD",
      colStatusHeader: "STATUS",
      colActions: "ACTIONS",
      ongoing: "Ongoing",
      menuEdit: "Edit",
      menuUsage: "View usage",
      menuDistribute: "Distribute to customers",
      menuDelete: "Delete",
      distributeTitle: "Distribute \"{{code}}\" to customers",
      sendToWallet: "Send to wallet",
      distributeHint: "Search by phone or name, then select customers to place this voucher directly in their wallet.",
      distributeSearch: "Search by phone or name…",
      distributeSelect: "Select customers",
      distributionSuccess: "Voucher sent to {{count}} customer(s)",
      usageTitle: "Usage — \"{{code}}\"",
      usageEmpty: "This voucher has not been redeemed on any order yet.",
      usageSlot: "Source",
      usageDiscount: "Discount",
      slotMerchantPlatform: "Merchant / Platform",
      slotPlatform: "Platform",
      slotDeliveryFee: "Delivery fee",
      typeTagPercentage: "PERCENTAGE",
      typeTagFixed: "FIXED AMOUNT",
      typeTagFreeItem: "FREE ITEM",
      drawerSubtitleNew: "Configure your promotion details below",
      btnCancel: "CANCEL",
      btnSaveChanges: "SAVE CHANGES",
      btnSaveVoucher: "SAVE VOUCHER",
      sectionBasic: "Basic Information",
      sectionDiscount: "Discount Settings",
      sectionUsage: "Usage Limits",
        sectionAutoGrant: "Auto-Grant",
        lblAutoGrantTrigger: "Automatically grant when",
        autoGrantNone: "Manual / broadcast only",
        autoGrantFirstOrder: "Customer completes their first order",
        autoGrantHint: "When set, this voucher is added to a customer's wallet automatically the moment the trigger condition is met — no claiming needed.",
      sectionValidity: "Validity Period",
      sectionApplicable: "Applicable To",
      lblVoucherName: "Voucher Name",
      phVoucherName: "e.g., Weekend Coffee Deal",
      lblVoucherCode: "Voucher Code",
      codeRequired: "Code is required",
      btnAutoGenerate: "AUTO-GENERATE",
      lblDescription: "Description",
      lblVoucherImage: "Voucher Image (thumbnail)",
      tabPercentage: "Percentage",
      tabFixedRm: "Fixed RM",
      tabFreeDelivery: "Free Delivery",
      tabApplicableAll: "All",
      tabApplicablePickup: "Pickup",
      tabApplicableDelivery: "Delivery",
      lblValuePct: "Value (%)",
      lblMaxCapRm: "Max Cap (RM)",
      lblDiscountAmountRm: "Discount Amount (RM)",
      freeDeliveryHint: "Delivery fee will be waived entirely",
      lblMinOrderRm: "Minimum Order Value (RM)",
      lblTotalUsageLimit: "Total Usage Limit",
      lblPerCustomer: "Per Customer",
      lblStartDate: "Start Date",
      lblEndDate: "End Date",
      enableImmediatelyTitle: "Enable Voucher immediately",
      enableImmediatelyHint: "STATUS WILL BE 'ACTIVE' UPON SAVING",
      filterStatusActive: "Active",
      filterStatusScheduled: "Scheduled",
      filterStatusExpired: "Expired",
      filterStatusDisabled: "Disabled",
      filterTypePercentage: "Percentage",
      filterTypeFixed: "Fixed Amount",
      filterTypeFreeItem: "Free Item",
    },
    bundles: {
      title: "Bundles",
      pageTitle: "Promotions",
      pageSubtitle: "Create, price and manage bundle promotions",
      newBundle: "New Bundle",
      createBundle: "Create Bundle",
      editTitle: "Edit Bundle",
      newTitle: "New Bundle",
      colName: "Name",
      colBundlePrice: "Bundle Price",
      colOriginalPrice: "Original",
      colFor: "For",
      colValid: "Valid",
      colActive: "Active",
      formName: "Name",
      formDescription: "Description",
      formItemsLabel: "Items (select stall first)",
      formStall: "Stall",
      formItemsJson: "Bundle items (JSON)",
      formOriginalPrice: "Original Price (RM)",
      formBundlePrice: "Bundle Price (RM)",
      formApplicableFor: "Applicable for",
      formApplicableBoth: "Both",
      formApplicablePickup: "Pickup",
      formApplicableDelivery: "Delivery",
      formValidityPeriod: "Validity period",
      formIsActive: "Active",
      confirmDelete: "Delete this bundle?",
      deleteTitle: "Delete this bundle?",
      deleteContent: "This action is permanent and cannot be undone.",
      deleteBtn: "Delete",
      createSuccess: "Bundle created",
      updateSuccess: "Bundle updated",
      deleteSuccess: "Bundle deleted",
      saveFailed: "Failed to save bundle",
      deleteFailed: "Failed to delete bundle",
      statTotal: "Total bundles",
      statActive: "Active",
      statDisabled: "Disabled",
      statBadgeOverall: "Overall",
      statBadgeActive: "Active",
      statBadgeDisabled: "Inactive",
      searchPlaceholder: "Search bundle name…",
      statusAll: "Status: All",
      statusActiveOnly: "Active",
      statusDisabledOnly: "Disabled",
      applicableAll: "Applicable: All",
      applicableBoth: "Pickup & delivery",
      applicablePickup: "Pickup only",
      applicableDelivery: "Delivery only",
      tabAll: "All",
      tabPickup: "Pickup",
      tabDelivery: "Delivery",
      loading: "Loading…",
      empty: "No bundles found.",
      drawerSubtitleCreate: "Configure your bundle details below",
      cancel: "Cancel",
      saveChanges: "Save changes",
      saveBundle: "Save bundle",
      sectionBasic: "Basic information",
      bundleName: "Bundle name",
      nameRequired: "Bundle name is required",
      namePlaceholder: "e.g. Breakfast set",
      description: "Description",
      sectionItems: "Item in this bundle",
      addItem: "Add item",
      searchItemPlaceholder: "Search item by name or stall…",
      noItemsFound: "No items found",
      noItemsYet: "No items added yet",
      originalTotal: "Original total:",
      sectionBundlePrice: "Bundle price",
      splitCost: "Split cost (per unit)",
      splitTotal: "Split cost total",
      platformKeeps: "Platform keeps RM {{amount}}",
      splitOverWarning: "Split costs exceed the bundle price by RM {{amount}} — the platform would lose money on each bundle.",
      bundlePriceRm: "Bundle price (RM)",
      originalPrice: "Original price",
      bundlePriceRow: "Bundle price",
      customerSaves: "Customer saves",
      sectionApplicable: "Applicable to",
      setExpiry: "Set expiry date",
      noExpiryHint: "This bundle has no expiry date.",
      startDate: "Start date",
      endDate: "End date",
      activeStatus: "Active status",
      activeStatusHint: "Disable to hide this bundle without deleting it.",
      pillActive: "Active",
      pillDisabled: "Disabled",
      previewAction: "Preview",
      unknownStall: "Unknown stall",
    },
    settlement: {
      gross: "Gross (list price)",
      stallFee: "Item deduction (on the stall menu price)",
      addonFee: "Add-on deduction (on add-on cost)",
      bundleFee: "Bundle deduction (on the bundle price)",
      bundleShare: "Bundle discount share",
      cutlery: "of which cutlery",
      net: "Net payable",
      deductions: "Deductions",
      orders: "Orders",
      stall: "Stall",
      allStalls: "All stalls",
      from: "From",
      to: "To",
      byStall: "By stall",
      byOrder: "By order (what to pay each stall)",
      orderCode: "Order",
      orderTime: "Order time",
      exportSettlement: "Export settlement CSV",
      exportLines: "Export order lines CSV",
      exportBundles: "Export bundles CSV",
      invalidRange: "The start date must not be after the end date.",
      formulaHint: "Stall-side statement: Gross = stall menu price + add-on cost. Item deduction = a flat amount when the menu price is at or below the threshold, otherwise a percentage; add-on deduction = a percentage of the add-on cost; bundle deduction = the same rule on the bundle price. Net payable = gross − item − add-on − bundle deduction − bundle discount share. Customer-side markup is not part of it. All numbers come from what was recorded on each order at order time; cancelled orders and rejected items are excluded.",
    },
    reports: {
      title: "Reports",
      granularityHourly: "Hourly",
      granularityDaily: "Daily",
      granularityWeekly: "Weekly",
      granularityMonthly: "Monthly",
      presetToday: "Today",
      presetLast7: "Last 7 days",
      presetLast30: "Last 30 days",
      presetThisMonth: "This month",
      chartRevenueOrders: "Revenue & Orders Over Time",
      chartNoData: "No data for selected period",
      chartRevenueByStall: "Revenue by Stall",
      chartNoDataShort: "No data",
      tableStallBreakdown: "Stall Breakdown",
      colStall: "Stall",
      colRevenue: "Revenue",
      colOrders: "Orders",
      colAvgOrder: "Avg Order",
      tableTotal: "Total",
      dataRange: "Data from {{from}} to {{to}}",
      tabFinancial: "Financial",
      tabRisk: "Risk",
      tabStalls: "Sales by stall",
      tabStaff: "Staff activity",
      tabPricing: "Pricing breakdown",
      tabSettlement: "Stall settlement",
      colQty: "Qty",
      colBasePriceTotal: "Base price total",
      colMarkupTotal: "Customer markup (platform charges customers)",
      colBundleDiscount: "Bundle discount",
      colStallDeduction: "Stall deduction (platform charges stalls)",
      colPlatformIncome: "Platform income (customer markup + stall deduction)",
      colSstIncluded: "SST included in prices (not in revenue / platform income)",
      colOptionsTotal: "Add-on total",
      colOptionsMarkupTotal: "Add-on customer markup",
      pricingBreakdownTitle: "Base price vs markup — monthly",
      pricingBreakdownSub: "Per-stall base price and markup totals, filterable by stall and order category (walk-in vs customer-app). Walk-in orders always carry RM0.00 markup.",
      filterMonth: "Month",
      filterStall: "Stall",
      filterAllStalls: "All stalls",
      filterCategory: "Order category",
      categoryAll: "All orders",
      categoryWalkin: "Walk-in (POS)",
      categoryCustomerApp: "Customer app",
      rowGrandTotal: "Grand total",
      periodToday: "Today",
      periodWeek: "This week",
      periodMonth: "This month",
      cardTotalRevenue: "Order total (excl. cancelled)",
      cardTotalRefunds: "Total refunds",
      refundTxCount: "{{count}} completed refunds (pending requests not counted)",
      cardNetRevenue: "Net revenue",
      afterRefunds: "= order total − refunds on counted orders",
      cardTotalRevenueHint: "Order total = sum of all non-cancelled orders in the period (including unpaid ones). The Transactions page counts only successful payments, so the two differ.",
      refundsOnCancelled: "{{count}} more refunds (RM {{amount}}) belong to cancelled orders and are not in revenue",
      colCancelledRefunds: "Refunds on cancelled",
      cardTotalOrders: "Total orders",
      pickupDelivery: "Pickup & delivery",
      revVsLastPeriod: "{{pct}}% vs last period",
      legendRevenue: "Revenue",
      legendOrders: "Orders",
      salesTrend: "Sales trend",
      paymentMethods: "Payment methods",
      payMixEwallet: "e-Wallet (TNG / GoPay)",
      payMixCard: "Credit / debit card",
      payMixCash: "Cash",
      topPerformer: "Top performer",
      topPerformerSub: "Nasi Lemak e-wallet user",
      revenueTrend: "Revenue trend",
      revenueTrendSub: "Daily financial performance overview",
      legendRefunds: "Refunds",
      dailyBreakdown: "Daily breakdown",
      colDate: "Date",
      colRefunds: "Refunds",
      colNetRevenue: "Net revenue",
      recentFinancialTx: "Recent financial transactions",
      viewAll: "View all",
      colTxnId: "Transaction ID",
      colStatus: "Status",
      colMethod: "Method",
      colAmount: "Amount",
      riskCancelRate: "Cancellation rate",
      riskRefundRate: "Refund rate",
      cancelledOrdersCount: "{{count}} cancelled orders",
      refundedOrdersCount: "{{count}} refunded orders",
      riskCancelledOrders: "Cancelled orders",
      thisPeriod: "This period",
      riskRefundedAmt: "Refunded amount",
      totalRefundedHint: "Total refunded",
      highRiskOrders: "High-risk orders",
      colOrderId: "Order ID",
      colCustomerName: "Customer name",
      colOrderType: "Order type",
      colReason: "Reason",
      colActions: "Actions",
      paginationShowing: "Showing {{start}}–{{end}} of {{total}} entries",
      salesByStallTitle: "Sales by stall (RM)",
      salesByStallSub: "Revenue breakdown per vendor",
      revenueShare: "Revenue share",
      donutTotal: "Total",
      topItemsTitle: "Top items by stall",
      topItemsSub: "Performance ranking of menu items",
      colRank: "Rank",
      colItemName: "Item name",
      colUnitsSold: "Units sold",
      colRevenueRm: "Revenue (RM)",
      colPerformance: "Performance",
      colCommission: "Commission",
      commissionThreshold: "Threshold (≤)",
      commissionFlatFee: "Flat fee",
      commissionPercent: "Percent (>threshold)",
      commissionSave: "Save commission rule",
      addonCommissionPercent: "Add-on deduction (%)",
      commissionReportOnlyHint: "These rates are for this report's own cost-deduction/reconciliation calculation only — separate from Pricing Rules, and never affect what customers are actually charged at checkout.",
      staffBadgeVsLw: "+12% vs last week",
      staffActiveToday: "Active staff today",
      staffRegisteredOf: "/ {{count}} registered",
      avgSessionDuration: "Avg session duration",
      perStaffToday: "Per staff today",
      totalLoginSessions: "Total login sessions",
      includingRelogins: "Including re-logins",
      staffLoginLogTitle: "Staff login / logout log",
      staffLoginLogSub: "Monitoring active device sessions",
      searchStaffPh: "Search staff name…",
      colStaffName: "Staff name",
      colDevice: "Device",
      colLoginTime: "Login time",
      colLogoutTime: "Logout time",
      colDuration: "Duration",
      ongoing: "(ongoing)",
      sessionFootnote:
        "* Session recorded when staff logs in and out of the tablet POS. Duration is updated in real time.",
      statusCancelled: "Cancelled",
      statusRefunded: "Refunded",
      staffOnline: "● Online",
      staffOnlineRelogin: "● Online (re-login)",
      staffLoggedOut: "Logged out",
      demo: {
        dash: "—",
        avgSessionSample: "5h 22m",
        riskStatCancelRate: "4.2%",
        riskStatRefundRate: "1.0%",
        riskRefundedAmount: "RM 185.00",
        risk: {
          trm1042: { customer: "Ahmad Fadzil", reason: "No rider available" },
          trm1038: { customer: "Sarah Lim", reason: "Wrong item sent" },
          trm1035: { customer: "John Tan", reason: "Late delivery (>45m)" },
          trm1031: { customer: "Mei Ling", reason: "Customer not present" },
        },
        staff: {
          s0: {
            name: "Ahmad Bakar",
            device: "Tablet 1",
            login: "7:02 AM",
            logout: "—",
            duration: "7h 13m",
          },
          s1: {
            name: "Siti Aminah",
            device: "Tablet 2",
            login: "8:15 AM",
            logout: "2:15 PM",
            duration: "6h 00m",
          },
          s2: {
            name: "Jason Tan",
            device: "Tablet 1",
            login: "9:00 AM",
            logout: "—",
            duration: "5h 15m",
          },
          s3: {
            name: "Mary Jane",
            device: "Tablet 2",
            login: "7:30 AM",
            logout: "12:00 PM",
            duration: "4h 30m",
          },
          s4: {
            name: "Mary Jane",
            device: "Tablet 2",
            login: "1:00 PM",
            logout: "—",
            duration: "3h 15m",
          },
          s5: {
            name: "Lee Chong Wei",
            device: "Tablet 1",
            login: "6:45 AM",
            logout: "3:30 PM",
            duration: "8h 45m",
          },
        },
        top: {
          nasi: [
            "Nasi Lemak Ayam Berempah",
            "Nasi Lemak Biasa",
            "Nasi Lemak Sambal Sotong",
            "Extra Sambal (Add-on)",
          ],
          drinks: ["Teh Tarik", "Milo Ais", "Teh O Ais Limau", "Kopi O"],
          wok: ["Fried Rice", "Char Kway Teow", "Mee Goreng Mamak"],
          mamak: ["Roti Canai", "Maggi Goreng", "Naan + Curry"],
        },
      },
    },
    activity: {
      title: "Activity Log",
      colStaff: "Staff",
      colAction: "Action",
      colEntity: "Entity",
      colDetails: "Details",
      colIp: "IP address",
      colTime: "Time",
      searchPlaceholder: "Search staff, order no. (e.g. 5906) or details…",
      filterAction: "Filter action",
      exportCsv: "Export CSV",
      clearFilters: "Clear filters",
      allActions: "All actions",
      eventsRecorded: "{{count}} events recorded",
      footerShowing: "Page {{page}} · {{total}} total events",
    },
    notifications: {
      deliveryFailedTitle: "Delivery failed — Order {{code}}",
      title: "Notifications",
      markAllRead: "Mark all read",
      empty: "No notifications yet.",
      resolved: "Resolved",
      unresolved: "Unresolved",
    },
    imageUpload: {
      imagesOnly: "Only image files are allowed",
      maxSize: "Image must be under 5 MB",
      uploadFailed: "Upload failed",
      upload: "Upload",
      previewAlt: "Uploaded image preview",
      clickOrDrag: "Click to upload or drag and drop",
      hintFormats: "SVG, PNG, JPG (max. 5 MB). Square 1:1 recommended.",
      menuItemHint: "Recommended: 1200×1200px, JPG, under 1MB. Square, dish centered — shown as the thumbnail in menu lists and home screen.",
      stallHint: "PNG, JPG or WebP up to 5 MB. A clear landscape stall image is recommended.",
      squareLabel: "Square Photo (thumbnail)",
      wideLabel: "Landscape Photo (banner)",
      wideHint: "Recommended: 1200×900px, JPG, under 1MB. Landscape, dish centered — shown as the banner on the item detail page. Optional — falls back to the square photo if not set.",
    },
    statusTag: {
      new: "New",
      pending: "Pending",
      confirmed: "Confirmed",
      preparing: "Preparing",
      ready: "Ready",
      out_for_delivery: "Out for delivery",
      in_transit: "In transit",
      delivered: "Delivered",
      completed: "Completed",
      cancelled: "Cancelled",
      paid: "Paid",
      unpaid: "Unpaid",
      refunded: "Refunded",
      partially_refunded: "Partially refunded",
      approved: "Approved",
      rejected: "Rejected",
      pending_review: "Pending review",
      active: "Active",
      inactive: "Inactive",
      open: "Open",
      closed: "Closed",
    },
    issueRefund: {
      title: "Process refund",
      notFound: "Transaction not found.",
      txnId: "TXN ID:",
      orderId: "Order ID:",
      datePaid: "Date paid",
      back: "Back",
      sectionRefundType: "Refund type",
      fullRefund: "Full refund",
      fullRefundDesc: "Refund the full transaction amount of RM {{amount}} to the original source.",
      partialRefund: "Partial refund",
      partialDesc: "Specify a custom amount to return to the customer.",
      maxRefundable: "Max refundable: RM {{amount}}",
      overLimit: "The refund is more than the RM {{amount}} that can be refunded — lower it",
      sectionBreakdown: "Refund breakdown",
      foodBev: "Food & beverages",
      deliveryFee: "Delivery fee",
      sst: "SST ({{rate}}%)",
      appliedDiscount: "Applied discount",
      refundAmountRow: "Refund amount",
      totalRefundAmount: "Total refund amount",
      sectionReason: "Reason & documentation",
      refundReasonLabel: "Refund reason",
      reasonPlaceholder: "Select a reason…",
      internalNote: "Internal note",
      internalOptional: "(optional)",
      internalPlaceholder: "Details for merchant auditing…",
      sectionMethod: "Refund method",
      methodDescFallback: "Funds will be returned to the original payment instrument.",
      originalPaid: "Original paid amount",
      settlementSummary: "Settlement summary",
      warningIrreversible: "This cannot be undone. The refund will be sent to the payment gateway immediately.",
      confirmCheckbox: "I confirm I verified the order and authorize this refund.",
      confirmRefund: "Confirm refund",
      cancelReturn: "Cancel and return",
      merchantId: "Merchant ID:",
      authorizedBy: "Authorized by:",
      roleAdmin: "admin",
      partialTipTitle: "Partial refund tip",
      partialTipBody: "For missed items, use per-unit price before SST for accurate reimbursement.",
      success: "Refund initiated successfully",
      failed: "Failed to initiate refund. Please try again.",
      payVisa: "Visa / card — verified",
      payFpx: "FPX — verified",
      payGrab: "GrabPay — verified",
      payCash: "Cash",
      payEwallet: "eWallet — verified",
      payTng: "Touch 'n Go — verified",
      payBoost: "Boost — verified",
      descVisa: "Returned to the original card. 5–7 business days.",
      descFpx: "Returned to the original instrument. 3–5 business days.",
      descGrab: "Returned to GrabPay wallet. 1–3 business days.",
      descCash: "Hand cash to the customer directly.",
      descEwallet: "Returned to the original eWallet. 1–3 business days.",
      descTng: "Returned to Touch 'n Go wallet. 1–3 business days.",
      descBoost: "Returned to Boost wallet. 1–3 business days.",
      reasonCustomerCancelled: "Customer cancelled",
      reasonOutOfStock: "Out of stock",
      reasonWrongItem: "Wrong item",
      reasonDuplicate: "Duplicate payment",
      reasonNotDelivered: "Order not delivered",
      reasonQuality: "Quality issue",
      reasonOther: "Other",
    },
    receipt: {
      metaReceiptNo: "Receipt no.",
      metaOrderId: "Order ID",
      metaDateTime: "Date & time",
      metaPaymentMethod: "Payment method",
      metaCustomerName: "Customer name",
      metaCustomerPhone: "Customer phone",
      metaOrderChannel: "Order channel",
      tel: "Tel.",
      colItemName: "Item name",
      colQty: "Qty",
      colPriceRm: "Price (RM)",
      colSubtotalRm: "Subtotal (RM)",
      subtotal: "Subtotal",
      deliveryFee: "Delivery fee",
      discount: "Discount",
      totalPaid: "Total paid",
      sstPct: "SST ({{pct}}%)",
      refundedAmount: "Refunded amount",
      refundDate: "Refund date",
      thankYou: "Thank you for your purchase",
      systemGenerated: "This is a system generated receipt",
      downloadPdf: "Download PDF",
      printReceipt: "Print receipt",
      close: "Close",
      printTitle: "Receipt",
      optionsPlus: "+",
      payVisa: "Visa / Card",
      payFpx: "FPX",
      payGrab: "GrabPay",
      payCash: "Cash",
      payEwallet: "eWallet",
      payTng: "Touch 'n Go",
      payBoost: "Boost",
      channelDelivery: "Delivery",
      channelPickup: "Pickup",
      channelOther: "Order",
    },
    addMenuItem: {
      titlePage: "Add new item",
      titlePageEdit: "Edit item",
      successCreate: "Menu item created",
      successUpdate: "Menu item updated",
      failedCreate: "Failed to create menu item",
      failedUpdate: "Failed to update menu item",
      successAnother: "Item saved! Fill in another.",
      sectionBasic: "Basic information",
      itemName: "Item name",
      itemNameRequired: "Item name is required",
      namePlaceholder: "e.g. Nasi Lemak Ayam Goreng",
      stall: "Stall",
      tagRequired: "Required",
      selectStallPh: "Select stall",
      category: "Category",
      selectCategoryPh: "Select category",
      stallPaused: "{{name}} is currently paused. The item will not be available until the stall is resumed.",
      description: "Description",
      descPlaceholder: "Short description of this item",
      sectionPricing: "Pricing & availability",
      basePrice: "Base price",
      priceRequired: "Price is required",
      availableForOrder: "Available for order",
      availableHint: "Switch off to hide from customer menu",
      pinToTop: "Pin to top",
      pinToTopHint: "Show this item first in the customer menu",
      advancedOptions: "Advanced options",
      offerPrice: "Offer price (RM)",
      dailyStock: "Daily stock",
      dailyStockPh: "e.g. 50",
      takeawayCutlery: "Takeaway cutlery fee",
      takeawayCutleryHint: "Charged per unit on customer-app pickup and delivery orders; customers cannot opt out.",
      takeawayCutleryFee: "Fee per unit",
      takeawayCutleryFeeRequired: "Enter the cutlery fee",
      sortOrder: "Sort order",
      availableFrom: "Available from",
      availableUntil: "Available until",
      offerFrom: "Offer from",
      timePh: "07:00",
      timePhEnd: "22:00",
      timePhOffer: "10:00",
      sectionImage: "Item image",
      sectionCustomization: "Customization engine",
      enableCustomization: "Enable customization",
      custPromptTitle: "Enable to add customizations",
      custPromptBody:
        'Turn on "Enable customization" above to add option groups such as size, add-ons, and sweetness.',
      noGroupsYet: 'No option groups yet. Click "Add option group" to start.',
      addOptionGroup: "Add option group",
      copyExistingGroup: "Copy an option group from this stall's other dishes…",
      icon: "Icon",
      groupName: "Group name",
      groupNamePh: "Group name (e.g. sugar level, add-ons)",
      fieldRequired: "Required",
      selection: "Selection",
      selectionSingle: "Single choice",
      selectionMultiple: "Multiple choice",
      min: "Min",
      max: "Max",
      removeGroup: "Remove group",
      colOptionName: "Option name",
      colPriceAdj: "Price adj. (RM)",
      colType: "Type",
      colDefault: "Default",
      optionNamePh: "Option name",
      typeRadio: "Radio",
      typeInput: "Input",
      typeTextarea: "Textarea",
      typeQuantity: "Quantity add-on",
      addOption: "Add option",
      customerPreview: "Customer preview",
      selectStallPreview: "Select stall above",
      previewNameFallback: "Item name preview",
      previewDescHint: "Description will appear here once you type in the details section.",
      badgeAvailable: "Available",
      badgeUnavailable: "Unavailable",
      customizeYourOrder: "Customize your order",
      mandatoryComplete: "All mandatory fields completed",
      mandatoryIncomplete: "Fill in required fields to continue",
      saveAddAnother: "Save & add another",
      saveItem: "Save item",
      groupIconSugar: "Sugar level",
      groupIconIce: "Ice level",
      groupIconSpecial: "Special request",
    },
    featureFlags: {
      title: "Feature Flags",
      pageSubtitle: "Control platform capabilities and rollout availability from one place.",
      statTotal: "Total flags",
      statEnabled: "Enabled",
      statDisabled: "Disabled",
      statBadgeTotal: "All capabilities",
      statBadgeEnabled: "Available now",
      statBadgeDisabled: "Turned off",
      toggleLabel: "Toggle {{key}}",
      colFlagKey: "Flag Key",
      colDescription: "Description",
      colEnabled: "Enabled",
      noDescription: "No description",
      flagEnabled: "Flag \"{{key}}\" enabled",
      flagDisabled: "Flag \"{{key}}\" disabled",
      updateFailed: "Failed to update flag",
      desc_lalamove_enabled: "Enable Lalamove rider dispatch for delivery orders",
      desc_email_otp_enabled: "Fall back to email OTP when SMS delivery fails",
      desc_bull_board_enabled: "Expose the background-job queue admin UI at /admin/queues",
      desc_customer_push_enabled: "Enable customer-side push notifications",
    },
    legalContent: {
      languageLabel: "Language",
      languageHint: "● marks a language that is already written. Readers see their own language; a language left empty falls back to English.",
      title: "Legal Content",
      subtitle: "Edit the Terms and Conditions / Privacy Policy shown in each app. Changes apply immediately to that app only.",
      applicationLabel: "Application",
      documentLabel: "Document",
      editorTitle: "Document editor",
      previewSubtitle: "Customer-facing preview",
      saveHint: "Changes apply to the selected application only.",
      appAdmin: "Admin Panel",
      appPos: "POS App",
      appStall: "Stall App",
      appCustomer: "Customer App",
      docTerms: "Terms and Conditions",
      docPrivacy: "Privacy Policy",
      titleLabel: "Title",
      contentLabel: "Content (Markdown supported: # heading, ## subheading, **bold**, - list items)",
      preview: "Preview",
      save: "Save",
      saveSuccess: "Saved",
      saveFailed: "Save failed, please try again",
      lastUpdated: "Last updated {{date}}",
      neverUpdated: "Not yet configured — showing placeholder text to users",
      unsavedContentHint: "Empty content will show a placeholder to users",
    },
    pricingRules: {
      title: "Pricing Rules",
      subtitle: "Per-item markup shown to customer-app orders (delivery + self-pickup). Walk-in POS orders always use the original menu price.",
      configurationTitle: "Pricing configuration",
      configurationSubtitle: "Set the customer-facing markup for base items and paid add-ons.",
      exampleSubtitle: "Values update instantly as you edit the rules. These rates are ONE side: the customer's price carries two of them (0.50 / 3.5% → menu price + RM1.00 / 7%) and the stall is deducted one (RM0.50 / 3.5%). Marked-up prices are always rounded UP to 10 sen. A bundle is marked up once, on its final bundle price, with the same rule (flat fee at or below the threshold, otherwise the percentage).",
      saveHint: "Changes apply after you save.",
      thresholdLabel: "Price threshold (RM)",
      thresholdHint: "Items priced at or below this amount get the flat fee. Items above it get the percentage instead.",
      flatFeeLabel: "Flat fee for items ≤ threshold (RM)",
      percentLabel: "Surcharge for items > threshold (%)",
      exampleTitle: "Live example",
      exampleLow: "RM {{price}} item → customer sees RM {{result}} (≤ threshold, flat fee)",
      exampleHigh: "RM {{price}} item → customer sees RM {{result}} (> threshold, {{percent}}% surcharge)",
      exampleAddon: "RM {{price}} add-on → customer sees RM {{result}} ({{percent}}% add-on markup, always applied)",
      exampleStallNet: "Stall est. revenue RM {{net}} (deducted RM {{fee}}; platform takes RM {{platform}} in total)",
      addonSectionTitle: "Add-on markup rate",
      addonSectionSub: "Applied to every paid add-on's own cost individually, regardless of which branch the base item's price took above. Independent from the base-item rule.",
      addonPercentLabel: "Add-on markup (%)",
      saveSuccess: "Pricing rules saved",
      saveFailed: "Failed to save pricing rules",
    },
    hours: {
      title: "Hours & Holidays",
      subtitle: "Manage weekly operating hours and exceptional closure dates.",
      cardOperatingHours: "Operating Hours",
      saveHours: "Save Hours",
      cardHolidays: "Holidays / Closures",
      colDate: "Date",
      colNote: "Note",
      addHolidayBtn: "Add",
      datePickerPlaceholder: "Select date",
      notePlaceholder: "Note (optional)",
      dateRequired: "Pick a date",
      confirmRemoveHoliday: "Remove holiday?",
      open: "Open",
      closed: "Closed",
      saveSuccess: "Operating hours saved",
      saveFailed: "Failed to save hours",
      updateHolidaySuccess: "Holiday updated",
      updateHolidayFailed: "Failed to update holiday",
      holidayAdded: "Holiday added",
      holidayAddFailed: "Failed to add holiday",
      days: {
        sunday: "Sunday",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
      },
    },
    settings: {
      title: "Settings",
      sectionBusiness: "Business Info",
      sectionTax: "Tax & Fees",
      fieldKopitiamName: "Kopitiam Name",
      fieldAddress: "Address",
      fieldPhone: "Contact Phone",
      fieldSstRate: "SST Rate (%)",
      fieldSstTooltip: "Enter as percentage, e.g. 6 for 6%",
      fieldDeliveryFee: "Default Delivery Fee (RM)",
      fieldDeliveryFeeTooltip: "Flat delivery fee charged to customers",
      saveBtn: "Save Settings",
      saveSuccess: "Settings saved",
      saveFailed: "Failed to save settings",
      addBtn: "Add",
    },
    settingsScreen: {
      coordsMissingBanner: "⚠️ The kopitiam (whole venue) has no coordinates yet: delivery distances are saved as 0, the delivery radius is not enforced and Lalamove quotes from a placeholder point. All stalls share this one location. Open Settings, enter the kopitiam address and look up its coordinates.",
      coordsMissingAction: "Open Settings",
      findByAddress: "Find coordinates from address",
      geoNeedAddress: "Enter the shop address first",
      geoFound: "Coordinates found from the address — check the map, then press Save.",
      geoApprox: "⚠️ This is only the general area near the address, NOT the exact shop location! Search the shop name in Google Maps, right-click its position, copy the coordinates and paste them into “Paste Google Maps coordinates” below, then Save.",
      pasteCoordsPh: "Paste Google Maps coordinates, e.g. 3.0123, 101.6123",
      pasteCoordsHint: "Most accurate: search the shop in Google Maps → right-click its position → click the first line (coordinates) to copy → paste here.",
      pasteCoordsBad: "Wrong format — it should look like 3.0123, 101.6123 (latitude, longitude)",
      gKeyTitle: "Google Maps API Key (optional)",
      gKeyOn: "Set (ends in {{last4}}). When “find coordinates” only gets an approximate match, Google is asked too.",
      gKeyOff: "Not set. Once set, “find coordinates” also asks Google when OpenStreetMap is only approximate (more accurate).",
      gKeyPh: "Paste the Google Geocoding API key",
      gKeySave: "Save key",
      gKeyReplace: "Replace key",
      gKeyRemove: "Remove",
      gKeySaved: "Saved",
      gKeyFailed: "Could not save — try again",
      geoNone: "No coordinates found for this address: check it (or just “postcode city, state”) or enter latitude/longitude by hand.",
      geoOpenMap: "View on map",
      geoSaveHint: "Remember to press Save when it looks right.",
      sstRateInvalid: "SST rate is required and must be between 0% and 100% (enter 0 for no SST)",
      payMethodsMovedHint: "Enable or disable cash, e-wallet, card and FPX for online checkout — including per-method gateway credentials — from the Payment Methods screen.",
      otherProvidersHint: "Configure Lalamove, GrabExpress and other delivery providers, including sandbox/production credentials and connection testing, from the Delivery Providers screen.",
      logoUpdated: "Logo updated",
      logoUpdateFailed: "Failed to save logo",
      baseFeeInvalid: "Default delivery fee is required and cannot be negative",
      sstRateRequired: "SST rate is required (enter 0 if you don't charge SST)",
      sstRateRange: "SST rate must be between 0 and 100",
      baseFeeRequired: "Default delivery fee is required",
      baseFeeNotNumber: "Delivery fee cannot be negative or non-numeric",
      baseFeeTooHigh: "Delivery fee cannot exceed RM 200",
      lblAppVersion: "App version label",
      appVersionHint: "Shown in the customer profile and the POS login footer.",
      goToDeliveryProviders: "Manage delivery providers",
      goToPaymentMethods: "Manage payment methods",
      title: "Settings",
      subtitle: "Manage store operations, customer channels and system preferences from one place.",
      saveChanges: "Save changes",
      saveSuccess: "Settings saved successfully",
      saveFailed: "Failed to save settings. Please try again.",
      storeNameRequired: "Store name is required",
      tabStore: "Store Info",
      tabDelivery: "Delivery",
      tabTax: "Tax & Currency",
      tabPayment: "Payment",
      tabPrinter: "Printer",
      tabNotifications: "Notifications",
      tabSms: "SMS Templates",
      smsTemplatesTitle: "OTP Message Templates",
      smsTemplatesExtra: "What gets texted to customers when they log in",
      lblSmsDefaultLang: "DEFAULT SEND LANGUAGE",
      smsDefaultLangHint: "Which template below is actually used to send the code — change any time, no code changes needed.",
      langChinese: "中文 (Chinese)",
      lblSmsTemplateZh: "CHINESE TEMPLATE",
      lblSmsTemplateEn: "ENGLISH TEMPLATE",
      lblSmsTemplateMs: "MALAY TEMPLATE",
      defaultBadge: "Default",
      smsTemplateHint: "Use {code} for the verification code and {minutes} for how many minutes it's valid. Leave any language blank to use the built-in template shown as its placeholder.",
      smsPreviewTitle: "Preview",
      smsPreviewHint: "This is exactly what customers receive today, with a sample code.",
      otpLimitsTitle: "Verification Code Limits",
      otpLimitsExtra: "Applies to both SMS and email OTPs.",
      lblOtpDailyCap: "MAX SENDS PER DAY",
      lblOtpCooldownSeconds: "COOLDOWN BETWEEN SENDS (SECONDS)",
      lblOtpExpirySeconds: "CODE VALID FOR (SECONDS)",
      lblOtpCodeLength: "CODE LENGTH (DIGITS)",
      tabRegistration: "Registration",
      registrationTitle: "Customer Registration",
      registrationExtra: "Control which channels new customers can register with.",
      allowEmailRegistration: "Allow email registration",
      allowEmailRegistrationDesc: "Let new customers sign up using an email address.",
      allowPhoneRegistration: "Allow phone registration",
      allowPhoneRegistrationDesc: "Let new customers sign up using a phone number.",
      tabEmail: "Email",
      emailTitle: "Email Delivery",
      emailExtra: "Configure Resend or SMTP so registration and password-reset codes can be sent by email.",
      emailEnabled: "Enable email sending",
      emailEnabledDesc: "When off, codes are logged instead of sent — useful before you have real credentials.",
      emailProvider: "PROVIDER",
      emailProviderSmtp: "SMTP (e.g. Gmail)",
      resendApiKey: "RESEND API KEY",
      emailFromAddress: "FROM ADDRESS",
      smtpHost: "SMTP HOST",
      smtpPort: "PORT",
      smtpSecure: "Use SSL (port 465)",
      smtpUser: "SMTP USERNAME",
      smtpPass: "SMTP PASSWORD",
      smtpPassPlaceholder: "Gmail: use an App Password, not your login password",
      emailTemplatesTitle: "Email Templates",
      emailTemplatesExtra: "Customize the OTP email content per language.",
      lblEmailTemplateDefaultLang: "DEFAULT LANGUAGE",
      emailTemplateHint: "This language is used when sending OTP emails.",
      lblEmailTemplateSubject: "SUBJECT",
      lblEmailTemplateHeading: "HEADING",
      lblEmailTemplateIntro: "INTRO TEXT",
      lblEmailTemplateOutro: "OUTRO TEXT",
      emailTemplatePlaceholderHint: "Use {code} for the verification code and {minutes} for how many minutes it's valid. Leave any field blank to use the built-in default.",
      sectionBasicInfo: "Basic Info",
      lblStoreName: "STORE NAME",
      lblPhone: "PHONE",
      lblEmail: "EMAIL",
      lblAddress: "ADDRESS",
      lblLatitude: "LATITUDE",
      lblLongitude: "LONGITUDE",
      useCurrentLocation: "Use current location",
      locationHint: "Real pickup coordinates for this food court — used as the delivery-quote origin so Lalamove fees and dispatch reflect the real distance instead of a placeholder.",
      geolocationUnsupported: "Location not supported by this browser",
      geolocationFailed: "Couldn't get your location",
      phPhone: "03-1234 5678",
      phEmail: "hello@kopitiam.com",
      sectionOrderTypes: "Accepted order types",
      allowPickupTitle: "Allow pickup orders",
      allowPickupDesc: "Customers can order online and pick up in-store",
      allowDeliveryTitle: "Allow delivery orders",
      allowDeliveryDesc:
        "Activate home delivery through your own riders or third-party",
      sectionBranding: "Store Branding",
      brandLogoTitle: "Brand Logo",
      brandLogoHint:
        "Accepted formats: PNG, JPG (Max 2MB). Recommended size: 512x512px.",
      uploadLogo: "Upload New Logo",
      sectionHours: "Operating hours",
      applyAllDays: "✓ Apply to all days",
      open: "OPEN",
      closed: "CLOSED",
      holidayHintBefore: "Holiday closures can be managed in the",
      holidayHintLink: "Special Dates",
      holidayHintAfter: "section.",
      sectionDeliveryFee: "Delivery fee",
      lblBaseFee: "BASE FEE",
      hintBaseFee: "Fixed start price for any delivery",
      lblFeePerKm: "FEE PER KM",
      hintFeePerKm: "Charge added for every kilometer traveled",
      lblMinFee: "MINIMUM FEE",
      hintMinFee: "Lowest possible delivery charge",
      lblMaxFee: "MAXIMUM FEE CAP",
      hintMaxFee: "Highest possible delivery charge",
      lblMarkupPct: "MARKUP %",
      hintMarkupPct: "Percentage markup added to calculated fee",
      feePreview: "Fee preview",
      dynamicEstimate: "DYNAMIC ESTIMATE",
      kmUnit: "{{n}} km",
      outOfRange: "OUT OF RANGE",
      sectionDeliveryRadius: "Delivery Radius",
      lblMaxRadius: "MAX DELIVERY RADIUS",
      hintRadius: "Orders outside this range will be rejected",
      kmSuffix: "km",
      saveFailedRadiusExceeded: "Max delivery radius cannot exceed {{max}} km",
      sectionRiderAssignment: "Rider assignment",
      readOnly: "READ ONLY",
      lblMethod: "METHOD",
      riderMethodManual: "Manual (admin assigns rider)",
      riderGpsNote:
        "This system uses manual rider assignment. GPS tracking is not available for internal riders.",
      thirdPartyTitle: "Third-party delivery integration",
      thirdPartySubtitle:
        "Automate dispatching by connecting to logistics providers.",
      providerNone: "None (manual)",
      providerLalamove: "Lalamove",
      providerGrabExpress: "GrabExpress",
      connected: "CONNECTED",
      setupRequired: "SETUP REQUIRED",
      lblApiKey: "API KEY",
      lastVerified: "Last verified: Today, 9:00 AM",
      disconnect: "Disconnect",
      editCredentials: "Edit credentials",
      lblClientId: "CLIENT ID",
      phEnterId: "Enter ID",
      lblClientSecret: "CLIENT SECRET",
      lblCountry: "COUNTRY",
      countryMalaysia: "Malaysia",
      lblEnvironment: "ENVIRONMENT",
      envSandbox: "Sandbox",
      envProduction: "Production",
      testConnection: "Test connection",
      sstConfigTitle: "SST configuration",
      sstConfigSubtitle:
        "Global SST: used by stalls that do not set their own rate, and always by bundles. SST is included in the price customers see — the cart and checkout no longer list it — and every order stores the rate and amount it charged, per line.",
      chargeSstLabel: "Charge SST on orders",
      lblSstRate: "SST RATE %",
      calcFormula: "CALCULATION FORMULA",
      calcFormulaBody: "Customer price = marked-up price x (1 + SST %), rounded up to 10 sen",
      exampleLabel: "Example:",
      exampleBody: "RM 10.00 x (1 + {{rate}}%), rounded up =",
      currencyTitle: "Currency display",
      currencySubtitle:
        "Global settings for how monetary values appear across the POS and Terminal.",
      lblCurrency: "CURRENCY",
      currencyReadonly: "MYR — Malaysian Ringgit",
      lblDisplayFormat: "DISPLAY FORMAT",
      displayFormatSample: "RM 12.50",
      lblStorageFormat: "STORAGE FORMAT",
      storageFormatSample: "Integer (cents) e.g. 1250",
      currencyLockedNote:
        "Currency settings are fixed. Contact support to change.",
      taxHelpTitle: "Need help with Tax Regulations?",
      taxHelpSubtitle:
        "View the Royal Malaysian Customs Department latest SST guide.",
      learnMore: "LEARN MORE",
      payMethodsTitle: "Payment methods",
      payMethodsSubtitle: "Configure how your customers pay for their orders.",
      payMinOneHint: "At least one payment method must be enabled.",
      transactionSettingsTitle: "Transaction settings",
      txnRecordedLabel: "TRANSACTION RECORDED",
      txnRecordedDesc: "Only recorded after successful payment",
      failedPayLabel: "FAILED PAYMENTS",
      failedPayDesc: "Not stored in the system",
      cashRefundTitle: "Cash refund",
      cashRefundDesc: "Allow processed cash refunds in the register",
      bankRefundTitle: "Bank transfer refund",
      bankRefundDesc: "Enable automated bank refund workflows",
      refundsManualNote: "Refunds are processed manually by admin.",
      payCashName: "Cash",
      payCashDesc: "Customer pays in person",
      payDuitnowName: "DuitNow QR",
      payDuitnowDesc: "Instant bank transfer via QR",
      payFpxName: "Online Banking (FPX)",
      payFpxDesc: "Direct bank transfer",
      payCardName: "Credit / Debit Card",
      payCardDesc: "Visa, Mastercard",
      payGrabpayName: "GrabPay",
      payGrabpayDesc: "GrabPay e-wallet",
      payTngName: "Touch 'n Go eWallet",
      payTngDesc: "TNG eWallet payment",
      printerSetup: "Printer setup",
      testPrint: "Test Print",
      lblPrinterName: "PRINTER NAME",
      printerNameDefault: "Main Kitchen Printer",
      lblConnType: "CONNECTION TYPE",
      connNetwork: "Network",
      connUsb: "USB",
      connBluetooth: "Bluetooth",
      lblIpAddress: "IP ADDRESS",
      lblPaperWidth: "PAPER WIDTH",
      autoPrintTitle: "Auto-print settings",
      autoKitchenName: "Print kitchen slip when order is accepted",
      autoKitchenDesc: "Sent to kitchen printer automatically",
      autoReceiptName: "Print receipt when order is completed",
      autoReceiptDesc: "Customer receipt printed on completion",
      manualPrintName: "Print on manual trigger only",
      manualPrintDesc: "Staff prints manually from order detail",
      kitchenSlipTitle: "Kitchen slip content",
      kitchenOrderId: "Order ID",
      kitchenOrderType: "Order type",
      kitchenCustomerName: "Customer name",
      kitchenItems: "Item list with customizations",
      kitchenSpecial: "Special instructions",
      kitchenEstTime: "Estimated time",
      receiptContentTitle: "Receipt content",
      receiptStoreAddr: "Store name & address",
      receiptOrderDate: "Order ID & date",
      receiptItemsPrices: "Item list with prices",
      receiptSubtotal: "Subtotal, delivery fee, SST, discount",
      receiptTotal: "Total amount",
      receiptPayMethod: "Payment method",
      livePreviewTitle: "Live Receipt Preview",
      livePreviewSubtitle:
        "Changes to your slip and receipt content will be updated instantly in your merchant dashboard.",
      previewStoreName: "KOPITIAM HUB",
      previewStoreAddr: "123 Street, Kuala Lumpur",
      previewItem1: "1x Teh O Ice",
      previewItem1Note: "- No Sugar",
      previewItem2: "1x Kaya Toast",
      previewTotal: "TOTAL",
      previewThankYou: "Thank You for Your Visit!",
      previewPrice1: "RM 3.50",
      previewPrice2: "RM 4.80",
      previewTotalAmount: "RM 8.30",
      demoMaskedApiKey: "sk_live_*******a2f",
      orderAlertsTitle: "Order alerts",
      orderAlertsExtra:
        "Configure how you are notified of real-time store activity.",
      alertNewOrder: "New order received",
      alertCancelled: "Order auto-cancelled",
      alertRider: "Rider assigned to delivery",
      alertDelayed: "Order delayed",
      tagSoundAlert: "SOUND ALERT",
      tagTabletPush: "TABLET PUSH",
      stallNotifTitle: "Stall notifications",
      stallNotifDesc:
        "Each stall receives push notifications on their own device showing only their items when an order is accepted.",
      flowAccepted: "Order accepted",
      flowFilters: "System filters items by stall",
      flowEachNotified: "Each stall gets notified with only their items",
      stallSampleNasi: "Nasi Lemak Stall",
      stallSampleDrinks: "Drinks Stall",
      stallSampleWok: "Wok Stall",
      stallSampleMamak: "Mamak Stall",
      stallDevice1: "Ali Hassan's iPhone",
      stallDevice2: "Nurul Ain's Samsung",
      stallDevice4: "Rajan's iPhone 12",
      stallInfo1: "iOS 17 • ACTIVE TODAY",
      stallInfo2: "Android 14 • ACTIVE TODAY",
      stallInfo4: "iOS 16 • ACTIVE 2 DAYS AGO",
      notLinked: "NOT LINKED",
      pairingCode: "KP-7F2A",
      enableAllStallsTitle: "Enable all stall notifications",
      enableAllStallsDesc:
        "Globally switch stall-specific alerts on or off.",
      lblNotifLang: "NOTIFICATION LANGUAGE",
      langEnglish: "English",
      langMalay: "Bahasa Melayu",
      alertSoundTitle: "Alert sound",
      lblVolume: "VOLUME",
      lblSoundTheme: "SOUND THEME",
      soundChime: "Chime",
      soundBell: "Bell",
      soundDing: "Ding",
      previewSound: "Preview sound",
      channelsTitle: "Channels",
      tabletPushTitle: "Tablet push notification",
      tabletPushDesc:
        "Send a pop-up alert to all active merchant tablets.",
      soundAlertChannelTitle: "Sound alert",
      soundAlertChannelDesc:
        "Play the selected theme sound when a notification arrives.",
      smsEmailUnavailable:
        "SMS and email notifications are not available in this version.",
      newOrderAlertBanner: "NEW ORDER ALERT",
      previewBadge: "PREVIEW",
      previewOrderTitle: "Order #1042 — Nasi Lemak Stall",
      previewOrderItems: "Nasi Lemak Ayam x2, Nasi Lemak Ikan x1",
    },
    stalls: {
      title: "Stalls",
      pageSubtitle: "Manage stall details, operating status and customer display order",
      statTotal: "Total stalls",
      statOpen: "Open stalls",
      statPaused: "Paused stalls",
      statBadgeOverall: "Overall",
      statBadgeOpen: "Open",
      statBadgePaused: "Paused",
      drawerSubtitleNew: "Enter the stall details and operating settings",
      addStall: "Add Stall",
      editTitle: "Edit stall",
      basicInfo: "Basic Info",
      status: "Status",
      stallStatus: "Stall Status",
      stallStatusHint:
        "If paused, all items under this stall will be unavailable",
      displayOrder: "Display Order",
      displayOrderHint: "Lower number appears first in the customer app",
      openingHours: "Opening Hours",
      weekdaysHours: "Mon – Fri",
      weekendHours: "Sat – Sun",
      stallName: "Stall Name",
      stallNameRequired: "Stall name is required",
      stallNamePlaceholder: "e.g. Beverage Stall",
      description: "Description",
      descriptionPlaceholder: "Short description of stall",
      discard: "Discard",
      createStall: "Create Stall",
      createSuccess: "Stall created",
      createFailed: "Failed to create stall",
      updateSuccess: "Stall updated",
      saveFailed: "Failed to save stall",
      opened: "Stall opened",
      closed: "Stall closed",
      colCover: "Cover",
      colName: "Name",
      colDescription: "Description",
      colSortOrder: "Sort",
      colSst: "SST",
      colOpen: "Open",
      colActions: "Actions",
      tooltipEdit: "Edit stall",
      tooltipDelete: "Delete stall",
      deleteConfirm: "Delete this stall? Its menu will be hidden from all apps.",
      deleteSuccess: "Stall deleted",
      deleteFailed: "Failed to delete stall",
      formName: "Name",
      formDescription: "Description",
      formCoverImage: "Stall cover",
      formSortOrder: "Sort order",
      formIsOpen: "Open for orders",
      formSst: "SST rate %",
      formSstHint: "Leave empty to follow the global SST; 0 = this stall charges no SST. The tax is inside the price customers see and only applies to new orders — existing orders keep the rate they were charged.",
      sstFollowGlobal: "Global",
      coverUrlPlaceholder: "https://…",
      hoursWeekdayExample: "08:00 AM – 10:00 PM",
      hoursWeekendExample: "09:00 AM – 11:00 PM",
    },
    banners: {
      title: "Promo Banners",
      pageSubtitle: "Manage promotional content, display order and publishing status",
      statTotal: "Total banners",
      statActive: "Active",
      statInactive: "Inactive",
      statBadgeOverall: "All banners",
      statBadgeActive: "Currently displayed",
      statBadgeInactive: "Paused",
      add: "Add Banner",
      editTitle: "Edit Banner",
      createTitle: "New Banner",
      colOrder: "Order",
      colTag: "Tag",
      colTitle: "Title",
      colPreview: "Preview",
      colActive: "Active",
      colActions: "Actions",
      sectionContent: "Banner content",
      sectionAppearance: "Image and appearance",
      sectionPublishing: "Order and publishing",
      updateSuccess: "Banner updated",
      createSuccess: "Banner created",
      saveFailed: "Failed to save banner",
      deleteConfirm: "Delete this banner?",
      deleteSuccess: "Banner deleted",
      deleteFailed: "Failed to delete banner",
      fieldTitle: "Title",
      titleRequired: "Title is required",
      titlePlaceholder: "e.g. Raya Special Deals",
      fieldTag: "Tag",
      tagRequired: "Tag is required",
      tagPlaceholder: "e.g. Promotion",
      fieldTagColor: "Tag Color",
      fieldImageUrl: "Banner Image",
      fieldOrder: "Sort Order",
      fieldActive: "Active",
      preview: "Preview",
      previewImageAlt: "Banner preview",
    },
    paymentMethods: {
      title: "Payment Methods",
      subtitle: "Configure payment gateways and API credentials",
      statTotal: "Total methods",
      statActive: "Active",
      statInactive: "Inactive",
      statSandbox: "Sandbox",
      statBadgeOverall: "Overall",
      statBadgeActive: "Enabled",
      statBadgeInactive: "Disabled",
      statBadgeSandbox: "Testing",
      addMethod: "Add Method",
      editTitle: "Edit Payment Method",
      newTitle: "New Payment Method",
      colProvider: "Gateway",
      colMethod: "Method",
      colDisplayName: "Display Name",
      colApiKey: "API Key",
      colQrCode: "QR Code",
      colStatus: "Active",
      colActions: "Actions",
      sectionGeneral: "General details",
      sectionCredentials: "Gateway credentials",
      sectionDisplay: "Display and status",
      formProvider: "Payment Gateway",
      formMethod: "Payment Method",
      formDisplayName: "Display Name",
      formApiKey: "API Key",
      formApiKeyPlaceholder: "Enter API key (stored encrypted)",
      formApiSecret: "API Secret",
      formApiSecretPlaceholder: "Enter API secret",
      formCollectionId: "Collection ID (Billplz) / Profile ID (Hyperswitch)",
      formMerchantId: "Merchant ID (Fiuu)",
      phMerchantId: "e.g. Fiuu Merchant ID",
      formWebhookSecret: "Webhook Secret",
      formWebhookSecretPlaceholder: "Enter webhook verification secret",
      formQrImageUrl: "QR Code Image URL",
      formSortOrder: "Sort Order",
      formIsActive: "Active",
      testConnection: "Test connection",
      confirmDelete: "Delete this payment method config?",
      createSuccess: "Payment method created",
      updateSuccess: "Payment method updated",
      deleteSuccess: "Payment method deleted",
      saveFailed: "Failed to save",
      deleteFailed: "Failed to delete",
      testFailed: "Connection test failed",
      phSelectProvider: "Select provider",
      phSelectMethod: "Select method",
      phDisplayName: "e.g. Billplz FPX, Cash Payment",
      phCollectionId: "e.g. Billplz Collection ID or Hyperswitch Profile ID",
      phQrUrl: "https://… (URL to QR code image)",
      colQrBadge: "QR",
      qrPreviewAlt: "QR code preview",
      providerBillplz: "Billplz (FPX/Cards)",
      providerToyyibpay: "ToyyibPay",
      providerStripe: "Stripe",
      providerManual: "Manual / Cash",
      providerQrStatic: "Static QR Code",
      providerGrabpay: "GrabPay Direct",
      providerBoost: "Boost",
      providerTng: "Touch 'n Go eWallet",
      providerHyperswitch: "Hyperswitch",
      providerFiuu: "Fiuu (Razer Merchant Services)",
      providerCustom: "Custom Provider",
      methodFpx: "FPX",
      methodVisa: "Visa / MasterCard",
      methodGrabpay: "GrabPay",
      methodCash: "Cash",
      methodEwallet: "eWallet",
      methodTng: "Touch 'n Go",
      methodBoost: "Boost",
      methodQr: "QR Code (Static)",
    },
    deliveryProviders: {
      formSandboxMode: "Test mode",
      sandbox: "Test environment",
      production: "Production",
      sandboxModeHint: "Uses the provider's test environment. Turn off only after configuring production credentials.",
      title: "Delivery Providers",
      subtitle: "Configure delivery API integrations and coverage settings",
      statTotal: "Total providers",
      statActive: "Active",
      statInactive: "Inactive",
      statSandbox: "Sandbox",
      statBadgeOverall: "All configurations",
      statBadgeActive: "In use",
      statBadgeInactive: "Paused",
      statBadgeSandbox: "Test configurations",
      addProvider: "Add Provider",
      editTitle: "Edit Delivery Provider",
      newTitle: "New Delivery Provider",
      colProvider: "Platform",
      colDisplayName: "Name",
      colApiKey: "API Key",
      colBaseUrl: "API Endpoint",
      colCoverage: "Coverage",
      colStatus: "Active",
      colActions: "Actions",
      sectionGeneral: "General information",
      sectionCredentials: "API & credentials",
      sectionOperations: "Service settings",
      formProvider: "Delivery Platform",
      formDisplayName: "Display Name",
      formApiKey: "API Key",
      formApiKeyPlaceholder: "Enter API key",
      formApiSecret: "API Secret",
      formApiSecretPlaceholder: "Enter API secret",
      formWebhookSecret: "Webhook Secret",
      formWebhookSecretPlaceholder: "Enter webhook secret",
      formBaseUrl: "API Base URL",
      formCoverageKm: "Coverage Radius",
      formSortOrder: "Sort Order",
      formIsActive: "Active",
      testConnection: "Test API connection",
      confirmDelete: "Delete this delivery provider?",
      createSuccess: "Delivery provider added",
      updateSuccess: "Delivery provider updated",
      deleteSuccess: "Delivery provider removed",
      saveFailed: "Failed to save",
      deleteFailed: "Failed to delete",
      testFailed: "API test failed",
      phSelectProvider: "Select provider",
      phDisplayName: "e.g. Lalamove Same Day",
      phBaseUrl: "https://rest.lalamove.com",
      unitKm: "km",
      coverageKm: "{{km}} km",
      providerLalamove: "Lalamove",
      providerGrabexpress: "GrabExpress",
      providerFoodpanda: "Foodpanda Delivery",
      providerPandago: "PandaGo",
      providerMyposrider: "MyPOS Rider",
      providerManual: "Manual (in-house)",
      providerCustom: "Custom API",
    },
    smsProviders: {
      title: "SMS Providers",
      subtitle: "Configure SMS/OTP API integrations and failover priority",
      statTotal: "Total providers",
      statActive: "Active",
      statHealthy: "Healthy",
      statInactive: "Inactive",
      statBadgeOverall: "All configurations",
      statBadgeActive: "In use",
      statBadgeHealthy: "Connection healthy",
      statBadgeInactive: "Paused",
      addProvider: "Add Provider",
      editTitle: "Edit SMS Provider",
      newTitle: "New SMS Provider",
      colProvider: "Provider",
      colDisplayName: "Name",
      colSortOrder: "Priority",
      colHealthy: "Health",
      colStatus: "Active",
      colActions: "Actions",
      sectionGeneral: "General information",
      sectionCredentials: "API & credentials",
      sectionOperations: "Service settings",
      healthy: "Healthy",
      unhealthy: "Unhealthy",
      formProvider: "SMS Provider",
      formDisplayName: "Display Name",
      formApiKey: "API Key",
      formApiKeyPlaceholder: "Enter API key",
      formApiSecret: "API Secret",
      formApiSecretPlaceholder: "Enter API secret",
      formWebhookSecret: "Webhook Secret",
      formWebhookSecretPlaceholder: "Enter webhook secret",
      formAccountSid: "Account SID",
      formAccountSidPlaceholder: "Enter Account SID",
      formAuthToken: "Auth Token",
      formAuthTokenPlaceholder: "Enter Auth Token",
      formMessagingServiceSid: "Messaging Service SID (optional)",
      formMessagingServiceSidHint: "Only needed if you send from a Messaging Service instead of a single number.",
      formMessagingServiceSidPlaceholder: "Enter Messaging Service SID",
      formSms123Email: "sms123.net Account Email",
      formSms123EmailHint: "The email your sms123.net account is registered under — required to submit templates for approval.",
      formSms123EmailPlaceholder: "e.g. you@company.com",
      submitTemplateTooltip: "Submit template for approval",
      submitTemplateTitle: "Submit Template to sms123.net",
      submitTemplateOk: "Submit",
      submitTemplateHint: "This only submits the request — sms123.net sends the approval result (approved/rejected) to their own callback, not here. Check your sms123.net dashboard for the outcome.",
      templateTitleLabel: "Template Title",
      templateTitlePlaceholder: "e.g. OTP Verification Code",
      templateContentLabel: "Message Content",
      templateContentHint: "Uses sms123.net's OWN placeholder syntax (%%) for the variable part — NOT the {code}/{minutes} placeholders from Settings > SMS Templates (those are substituted by our own system before sending, sms123.net never sees them). Also include the price-disclosure prefix and your company name, e.g. \"RM0 CompanyName : ...\" — confirmed directly by sms123.net support, not in their public docs.",
      templateContentPlaceholder: "e.g. RM0 KawKaw : Your verification code is %%. It expires in %% minutes.",
      templateSubmitFailed: "Failed to submit template",
      formBaseUrl: "API Base URL",
      formConfigJson: "Config (JSON)",
      formSortOrder: "Failover Priority",
      formIsActive: "Active",
      sortOrderHint: "Lower number tries first",
      configJsonHint: "This is the same request settings shown in the simple form above, as raw JSON — for edge cases the form can't express. Switch back any time.",
      builtInNote: "{{provider}} is preconfigured — nothing to fill in below except your credentials.",
      customConfigTitle: "Request Settings",
      customConfigHint: "Tell us what to send and how to read the response — no coding needed.",
      contentTypeLabel: "Send data as",
      contentTypeForm: "Form fields (most providers)",
      contentTypeQuery: "URL parameters (GET) — e.g. sms123.net",
      contentTypeJson: "JSON",
      authStyleLabel: "How to send the API Key",
      authStyleNone: "As one of the fields below",
      authStyleBearer: "As an Authorization header",
      bodyFieldsLabel: "Fields to send",
      fieldNamePlaceholder: "Field name (e.g. recipients)",
      customValuePlaceholder: "Fixed text to send",
      addField: "+ Add Field",
      value_phone: "Phone Number",
      value_message: "Message Text",
      value_apiKey: "API Key",
      value_apiSecret: "API Secret",
      value_referenceId: "Unique Request ID (auto-generated)",
      value_custom: "Fixed text…",
      advancedErrorHandling: "Reading the response (optional)",
      advancedErrorHandlingHint: "Only needed if the provider always returns success (HTTP 200) even on failure, with the real result inside the response body.",
      successFieldLabel: "Success field name",
      successFieldPlaceholder: "e.g. status",
      successValueLabel: "Value that means success",
      successValuePlaceholder: "e.g. ok",
      errorCodeFieldLabel: "Error code field name",
      errorCodeFieldPlaceholder: "e.g. msgCode",
      permanentCodesLabel: "Error codes that mean \"bad number, don't retry\"",
      permanentCodesHint: "Comma-separated. Leave blank if unsure — unrecognized codes are treated as retryable by default.",
      transientCodesLabel: "Error codes that mean \"try the next provider\"",
      transientCodesHint: "Comma-separated, e.g. insufficient balance or invalid credentials.",
      codesPlaceholder: "e.g. E00242, E00250",
      editRawJson: "Advanced: edit raw JSON",
      backToSimpleForm: "← Back to simple form",
      testConnection: "Send test SMS",
      testPhoneLabel: "Test phone number",
      testPhoneHint: "Leave blank to verify credentials only (Twilio only, no message sent, no cost). Enter a number to send a real test SMS — required for sms123/custom providers, which have no no-cost verification.",
      testPhonePlaceholder: "e.g. +60123456789",
      sendTest: "Send Test",
      confirmDelete: "Delete this SMS provider?",
      createSuccess: "SMS provider added",
      updateSuccess: "SMS provider updated",
      deleteSuccess: "SMS provider removed",
      saveFailed: "Failed to save",
      deleteFailed: "Failed to delete",
      testFailed: "SMS test failed",
      phSelectProvider: "Select provider",
      phDisplayName: "e.g. Twilio Primary",
      phBaseUrl: "https://api.sms123.example.com/send",
      phConfigJson: '{"content_type":"query","method":"GET","auth_style":"none","body_template":{"apiKey":"{{apiKey}}","recipients":"{{phone}}","messageContent":"{{message}}","referenceID":"{{referenceId}}"},"success_check":{"field":"status","equals":"ok"},"error_code_field":"msgCode","permanent_error_codes":["E00242"],"transient_error_codes":["E00250","E00359"]}',
      providerTwilio: "Twilio",
      providerSms123: "sms123",
      providerCustom: "Custom API",
    },
    login: {
      termsAndConditions: "Terms and Conditions",
      privacyPolicy: "Privacy Policy",
    },
  },
};
